import { Modal } from "react-bootstrap";
import { localStrings } from "src/utils/localization";
import Terms from "components/Terms";
import EcoPolicyComponent from "components/Common/Modal/JoinPolicy/EcoHistory";
import WrapsodyPolicyComponent from "components/Common/Modal/JoinPolicy/WrapsodyHistory";
import "./JoinPolicy.style.scss";
import { useTranslation } from "react-i18next";

interface IJoinPolicyUIProps {
  showPolicy: any;
  tabTarget: any;
  cancelButton: any;
  handleClickTab: any;
  showEcoPolicyHistory: any;
  showWrapsodyPolicyHistory: any;
  showEcoHistoryContent: any;
  hideEcoHistoryContent: any;
  showWrapsodyHistoryContent: any;
  hideWrapsodyHistoryContent: any;
}
const JoinPolicyUI = ({
  showPolicy,
  tabTarget,
  cancelButton,
  handleClickTab,
  showEcoPolicyHistory,
  showWrapsodyPolicyHistory,
  showEcoHistoryContent,
  hideEcoHistoryContent,
  showWrapsodyHistoryContent,
  hideWrapsodyHistoryContent,
}: IJoinPolicyUIProps) => {
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const language = i18n.language;
  const moveScrollTop = () => {
    const modalContent = document.querySelector(".modalWindow");
    if (modalContent) {
      modalContent.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
  };
  return (
    <Modal
      show={showPolicy}
      style={{ opacity: 1 }}
      // backdrop="static"
      className="policyModal"
      aria-labelledby="contained-modal-title"
      onHide={cancelButton}
    >
      <Modal.Dialog style={{ margin: 0, width: 840 }}>
        <Modal.Header style={{ padding: 0 }}>
          <div className="header">
            <ul className="tabs">
              <li
                className={`tab ${tabTarget === "tab1" ? "active" : ""}`}
                onClick={() => handleClickTab("tab1")}
              >
                {t("siteType.tab1")}
              </li>
              <li
                className={`tab ${tabTarget === "tab2" ? "active" : ""}`}
                onClick={() => handleClickTab("tab2")}
              >
                {t("siteType.tab2")}
              </li>
              {/* 유료 이용약관 */}
              {/* {window.sessionStorage.getItem("product") === "WRAPSODY_ECO" && (
                <li
                  className={`tab ${tabTarget === "tab3" ? "active" : ""}`}
                  onClick={() => handleClickTab("tab3")}
                >
                  {t("siteType.tab3")}
                </li>
              )} */}
            </ul>
            <div className="exit">
              <a onClick={cancelButton}>
                <i className="icon_cancel" />
              </a>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body className="modalWindow" style={{ width: "100%" }}>
          <div className="content-body">
            {/* 이용 약관 */}
            <div
              className={`tab_content ${tabTarget === "tab1" ? "active" : ""}`}
            >
              {showEcoPolicyHistory && (
                <EcoPolicyComponent
                  hideEcoHistoryContent={hideEcoHistoryContent}
                  tabTarget={tabTarget}
                />
              )}

              {showWrapsodyPolicyHistory && (
                <WrapsodyPolicyComponent
                  hideWrapsodyHistoryContent={hideWrapsodyHistoryContent}
                  tabTarget={tabTarget}
                />
              )}

              {!showEcoPolicyHistory &&
                !showWrapsodyPolicyHistory &&
                language === "ko" && (
                  <div className="modalWindow">
                    <div style={{ marginTop: "20px" }}>
                      <Terms></Terms>
                    </div>
                    {/* <ul>
                      <li>
                        <h3 className="title">1장 총칙</h3>
                        <ul>
                          <li>
                            <h4 className="subTitle">제1조 (목적)</h4>
                            <p className="contents">
                              본 약관은 주식회사 파수(이하 "회사")에서 제공하는
                              유무선 인터넷 서비스인 Wrapsody 및 Wrapsody eCo
                              서비스(이하 "서비스") 이용과 관련하여 회사와
                              회원과의 권리, 의무 및 책임사항, 기타 필요한
                              사항을 규정함을 목적으로 합니다.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">제2조 (용어의 정의)</h4>
                            <p className="contents">
                              본 약관에서 사용되는 용어의 정의는 다음과
                              같습니다.
                            </p>
                            <ul>
                              <li>
                                <p className="contents">
                                  서비스 : 회원이 컴퓨터, 휴대용 단말기 등 각종
                                  유·무선 기기 또는 프로그램을 통하여 이용할 수
                                  있도록 회사가 제공하는 모든 서비스를 말합니다.{" "}
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  회원 : 본 서비스에 접속하여 약관에 따라 회사와
                                  이용계약을 체결하고 회사가 제공하는 서비스를
                                  이용하는 고객을 말합니다.
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  사이트 : 서비스를 제공하는 Web 기반 유·무선
                                  홈페이지(https://*.wrapsody.com,
                                  https://*.wrapsodyeco.com)를 비롯한 서비스를
                                  말합니다.
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  애플리케이션 : 서비스를 제공하는 휴대용
                                  단말기에 설치되는 프로그램을 말합니다.
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  아이디(ID) : 회원의 식별과 회원의 서비스를
                                  위하여 회원이 입력한 e-mail(전자메일) 주소를
                                  의미합니다.
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  비밀번호(PASSWORD) : 회원을 식별하는 아이디와
                                  일치하는 회원임을 확인하고 비밀보호를 위해
                                  회원 자신이 정한 8자리 이상의 문자 또는 숫자,
                                  특수문자 조합을 의미합니다.
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  게시물 : 회원이 Wrapsody 및 Wrapsody eCo
                                  사이트에 등록하는 문서 등 모든 디지털 컨텐츠를
                                  의미합니다.
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  운영자 : 서비스의 전반적인 관리와 원활한
                                  운영을 위하여 회사에서 선정한 자를 의미합니다.
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  유료서비스 : 회사가 제공하는 서비스를 회원의
                                  필요에 따라 선택 할 수 있는 옵션 서비스를
                                  말합니다.{" "}
                                </p>
                              </li>
                            </ul>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              제3조 (약관의 효력 및 변경)
                            </h4>
                            <p className="contents">
                              본 약관은 서비스를 이용하고자 하는 모든 회원에
                              대하여 그 효력을 발생합니다.
                            </p>
                            <p className="contents">
                              본 약관은 회원이 서비스 가입 시 열람 할 수 있으며,
                              회사는 회원이 원할 때 언제든지 약관을 열람 할 수
                              있도록 사이트와 애플리케이션내에 게시합니다.
                            </p>
                            <p className="contents">
                              회사는 "약관의 규제에 관한 법률", "전자상거래
                              등에서의 소비자보호에 관한 법률", "정보통신망
                              이용촉진 및 정보보호", "온라인 디지털콘텐츠산업
                              발전법", "소비자기본법" 등 관련법에 위배되지 않는
                              범위 내에서 본 약관을 개정할 수 있습니다.{" "}
                            </p>
                            <p className="contents">
                              회사는 필요하다고 인정되는 경우 본 약관을 변경 할
                              수 있으며, 약관을 변경 할 경우에는 적용일자,
                              변경사유를 명시하여 적용일자 15일 전부터
                              공지합니다.
                            </p>
                            <p className="contents">
                              회사가 제3항에 따라 개정약관을 공지 또는
                              통지하면서, 회원에게 약관 변경 적용일까지
                              거부의사를 표시하지 아니할 경우, 약관의 변경에
                              동의한 것으로 간주한다는 내용을 공지 또는
                              통지하였음에도 회원이 명시적으로 약관 변경에 대한
                              거부의사를 표시하지 아니하면, 변경 약관에 동의한
                              것으로 간주합니다.{" "}
                            </p>
                            <p className="contents">
                              회원은 변경된 약관에 동의하지 아니하는 경우
                              서비스의 이용을 중단하고 이용계약을 해지할 수
                              있습니다.
                            </p>
                            <p className="contents">
                              회원은 약관의 변경에 대하여 주의의무를 다하여야
                              하며, 변경된 약관의 무지로 인한 회원의 피해는
                              회사가 책임지지 않습니다.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">제4조 (약관 외 준칙)</h4>
                            <p className="contents">
                              본 약관에 명시되지 않은 사항이 관계법령에 규정되어
                              있을 경우에는 그 규정에 따릅니다.
                            </p>
                            <p className="contents">
                              회사는 필요한 경우 서비스 내의 개별항목에 대하여
                              개별약관 또는 운영원칙을 정할 수 있으며, 본 약관과
                              개별약관 또는 운영원칙의 내용이 상충되는 경우에는
                              회사가 정한 내용을 우선으로 적용합니다.
                            </p>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <h3 className="title">2장 서비스 이용 계약</h3>
                        <ul>
                          <li>
                            <h4 className="subTitle">
                              제5조 (이용계약의 성립)
                            </h4>
                            <p className="contents">
                              이용계약은 회원가입 신청자가 본 약관 및
                              "개인정보처리방침"에 "동의합니다"를 선택하고,
                              회사가 정한 신청양식을 작성 한 후 서비스의 이용을
                              신청하면 회사가 이를 승낙함으로써 체결됩니다.
                            </p>
                            <p className="contents">
                              회사는 가입신청을 완료하였을 때에는 필요한 사항을
                              확인한 후 지체 없이 이를 승낙 하여야 합니다.
                            </p>
                            <p className="contents">
                              회원가입 신청자가 전체 항목에 "동의합니다"를
                              선택하고 신청양식을 작성하는 것은 본 약관 및
                              "개인정보처리방침"의 내용을 숙지하고, 회사가
                              서비스 이용을 위해 운영하는 각종 정책과 수시로
                              공지하는 사항을 준수하는 것에 대해 동의하는 것으로
                              봅니다.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              제6조 (이용계약의 유보 및 거절)
                            </h4>
                            <p className="contents">
                              회사는 다음 각 호에 해당하는 신청에 대하여는
                              승낙을 하지 않거나 사후에 이용계약을 해지할 수
                              있습니다.
                            </p>
                            <ul>
                              <li>
                                <p className="contents">
                                  1) 가입신청서의 내용을 허위로 기재한 경우
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  2) 다른 사람의 e-mail 인증을 수행하는 경우
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  3) 가입신청자가 본 약관에 의하여 이전에
                                  회원자격을 상실한 적이 있는 경우, 단 회사의
                                  회원 재가입 승낙을 얻은 경우에는 예외로 함
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  4) 회원의 귀책사유로 인하여 승인이
                                  불가능하거나 기타 규정한 제반 사항을 위반하며
                                  신청하는 경우
                                </p>
                              </li>
                            </ul>
                            <p className="contents">
                              제1항에 따른 신청에 있어 회사는 전문기관을 통한
                              실명확인 및 본인인증을 요청할 수 있다.
                            </p>
                            <p className="contents">
                              회사는 아래 각 호에 해당하는 경우에는 회원등록의
                              승낙을 유보할 수 있다.
                            </p>
                            <ul>
                              <li>
                                <p className="contents">
                                  1) 제공서비스 설비용량에 현실적인 여유가 없는
                                  경우
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  2) 서비스를 제공하기에는 기술적으로 문제가
                                  있다고 판단되는 경우
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  3) 회사가 재정적, 기술적으로 필요하다고
                                  인정하는 경우
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  4) 기타 귀책사유로 이용승낙이 곤란한 경우
                                </p>
                              </li>
                            </ul>
                            <p className="contents">
                              제1항과 제3항에 따라 회원가입신청의 승낙을 하지
                              아니하거나 유보한 경우, 회사는 원칙적으로 이를
                              가입신청자에게 알립니다.
                            </p>
                            <p className="contents">
                              이용계약의 성립 시기는 회사가 가입완료를 신청절차
                              상에서 표시한 시점으로 합니다.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              제7조 (회원의 관리책임)
                            </h4>
                            <p className="contents">
                              회원은 서비스 이용을 위한 아이디, 비밀번호의
                              관리에 대한 책임 등 회원의 고의ㆍ과실로 인해
                              발생하는 모든 불이익에 대한 책임을 부담합니다. 단,
                              이것이 회사의 고의ㆍ과실로 인하여 야기된 경우는
                              회사가 책임을 부담합니다.
                            </p>
                            <p className="contents">
                              회원은 아이디가 제3자가 사용하고 있음(대여 포함)을
                              인지한 경우에는 즉시 본인의 비밀번호를 수정하는
                              등의 조치를 취하여야 하며, 즉시 이를 회사에
                              통보하여 회사의 안내를 따라야 합니다.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              제8조 (개인정보보호 의무)
                            </h4>
                            <p className="contents">
                              회사는 서비스를 제공하기 위하여 기본적으로 필요한
                              아이디(이메일)와 비밀번호를 제외한 어떠한
                              개인정보도 수집하지 않습니다.
                            </p>
                            <p className="contents">
                              회사는 서비스 제공과 데이터의 출처 표기를 위해서
                              비밀번호를 제외한 회원이 가입 시 입력한 아이디를
                              사용할 수 있습니다.
                            </p>
                            <p className="contents">
                              회사는 회원이 회원 가입 시 입력한 비밀번호에
                              대해서 고수준의 암호화를 통해 회사 및 제3자가
                              알아낼 수 없도록 철저히 보호하도록 노력합니다.
                            </p>
                            <p className="contents">
                              회사의 "개인정보처리방침"은 서비스에 링크된 다른
                              웹사이트(회사가 운영하지 않는 웹사이트를 말합니다.
                              이하 같습니다)에서는 적용되지 않습니다.
                            </p>
                            <p className="contents">
                              회사는 필요한 경우 이러한 업무의 일부 또는 전부를
                              회사가 선정한 회사에 위탁할 수 있으며, 회원정보의
                              취급 및 관리, 서비스 운영 등에 관한 업무를
                              위탁하는 경우에는 "개인정보처리방침"에 공지합니다.
                            </p>
                            <p className="contents">
                              회사는 회원의 귀책사유로 인해 노출된 정보에 대해서
                              책임을 지지 않으며, 아래와 같은 경우에는 회원의
                              정보를 제공 할 수 있습니다.
                            </p>
                            <ul>
                              <li>
                                <p className="contents">
                                  1) 회원이 서비스를 이용함에 있어 관련 법률을
                                  위반하여 수사기관이나 기타 정부 기관으로부터
                                  정보제공을 요청 받는 경우
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  2) 회원의 법률위반, 본 서비스 약관위반을
                                  포함하여 부정행위 확인 등 정보보호 업무를 위해
                                  필요한 경우
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  3) 기타 법률에 의해 요구되는 경우
                                </p>
                              </li>
                            </ul>
                            <p className="contents">
                              회사는 "정보통신망법" 등 관계 법령이 정하는 바에
                              따라 회원의 개인정보를 보호하기 위해 노력합니다.
                              개인정보의 보호 및 사용에 대해서는 관련법 및
                              회사의 개인정보처리방침이 적용됩니다. 다만, 회사의
                              공식 사이트 이외의 링크된 사이트에서는 회사의
                              개인정보처리방침이 적용되지 않습니다.
                            </p>
                            <p className="contents">
                              회사는 상품 결제를 위하여 필요한 최소한의
                              정보(성명, 주소, 전화번호)를 요구 할 수 있으며,
                              결제 관련된 금융 정보는 저장하지 않습니다.
                            </p>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <h3 className="title">3장 서비스 이용</h3>
                        <ul>
                          <li>
                            <h4 className="subTitle">제 9조 (서비스의 제공)</h4>
                            <p className="contents">
                              회사는 회원에게 아래와 같은 서비스를 제공합니다.
                            </p>
                            <ul>
                              <li>
                                <p className="contents">
                                  1) Wrapsody 및 Wrapsody eCo (암호화된 문서의
                                  편집 및 공유 서비스)
                                </p>
                              </li>
                            </ul>
                            <p className="contents">
                              회원은 회사가 이용신청을 승낙한 때부터 서비스를
                              사용할 수 있습니다. 회사는 승낙한 때부터 서비스를
                              개시합니다. 다만, 유료 서비스의 경우 회사가
                              요금납입을 확인한 직후부터 사용 할 수 있습니다.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              제10조 (서비스의 이용시간)
                            </h4>
                            <p className="contents">
                              서비스는 연중무휴, 1일 24시간 제공함을 원칙으로
                              합니다. 회사는 서비스를 일정범위로 분할하여 각
                              범위 별로 이용가능시간을 별도로 지정할 수
                              있습니다.
                            </p>
                            <p className="contents">
                              회사는 서비스의 제공에 필요한 경우 수시점검 및
                              정기점검을 실시할 수 있으며, 점검시간은 서비스
                              제공화면에 공지한 바에 따릅니다.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              제11조 (서비스의 변경 및 중지)
                            </h4>
                            <p className="contents">
                              회사는 변경될 서비스의 내용 및 제공일자를
                              제20조에서 정한 방법으로 회원에게 이를 통지하고
                              서비스를 변경하여 제공할 수 있습니다.
                            </p>
                            <p className="contents">
                              회사는 다음 각 호에 해당하는 경우 서비스의 전부
                              또는 일부를 제한하거나 중지할 수 있습니다.
                            </p>
                            <ul>
                              <li>
                                <p className="contents">
                                  1) 회원이 회사의 영업활동을 방해하는 경우
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  2) 서비스 이용의 폭주 등으로 정상적인 서비스
                                  이용에 지장이 있는 경우
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  3) 전기통신사업법에 규정된 기간통신사업자가
                                  전기통신 서비스를 중지했을 경우
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  4) 제반 설비의 장애 또는 이용량의 폭주 등으로
                                  정상적인 서비스 이용에 지장이 있는 경우
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  5) 기타 중대한 사유로 인하여 회사가 서비스
                                  제공을 지속하는 것이 부적당하다고 인정하는
                                  경우
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  6) 기타 천재지변, 국가비상사태 등 불가항력적
                                  사유가 있는 경우
                                </p>
                              </li>
                            </ul>
                            <p className="contents">
                              제2항에 의한 서비스 중단의 경우에는 회사가
                              제21조에서 정한 방법으로 회원에게 통지합니다.
                              다만, 회사가 통제할 수 없는 사유로 인한 서비스의
                              중단(운영자의 고의ㆍ과실이 없는 디스크 장애,
                              시스템 다운 등)으로 인하여 사전 통지가 불가능한
                              경우에는 그러하지 아니합니다.
                            </p>
                            <p className="contents">
                              회사는 서비스의 변경, 중지로 발생하는 문제에
                              대해서는 어떠한 책임도 지지 않습니다.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              제12조 (정보의 제공 및 광고의 게재)
                            </h4>
                            <p className="contents">
                              회원은 서비스 이용 시 노출되는 광고 게재에 대해
                              동의합니다.
                            </p>
                            <p className="contents">
                              회사는 서비스 사용자를 대상으로 광고를 제공할 수
                              있습니다.
                            </p>
                            <p className="contents">
                              회원이 서비스상에 광고를 이용하거나 서비스를 통한
                              광고주의 판촉활동에 참여하는 등의 방법으로 교신
                              또는 거래를 하는 것은 전적으로 회원과 광고주 간의
                              문제입니다.
                            </p>
                            <p className="contents">
                              회원과 광고주간에 분쟁, 기타 문제가 발생하는 경우,
                              회원과 광고주가 직접 해결하여야 하며, 이와
                              관련하여 회사는 어떠한 책임도 지지 않습니다.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              제13조 (게시물의 저작권)
                            </h4>
                            <p className="contents">
                              회사는 게시한 회원의 동의 없이 게시물을 다른
                              목적으로 사용할 수 없습니다.
                            </p>
                            <p className="contents">
                              회사는 회원이 서비스 내에 게시한 게시물이 타인의
                              저작권, 기타 권리를 침해하더라도 이에 대한
                              민ㆍ형사상의 책임을 부담하지 않습니다. 만일 회원이
                              타인의 저작권 기타 권리를 침해하였음을 이유로
                              회사가 타인으로부터 손해배상청구 등 이의제기를
                              받은 경우, 회원은 회사의 면책을 위하여 노력하여야
                              하며, 회원은 그로 인해 회사에 발생한 모든 손해를
                              부담하여야 합니다.
                            </p>
                            <p className="contents">
                              회사는 회원이 이용계약을 해지하고 사이트를
                              탈퇴하거나 적법한 사유로 해지된 경우{" "}
                              <span>30일의 유예기간을 제공 후</span> 해당 회원이
                              게시하였던 게시물을 삭제할 수 있습니다.
                            </p>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <h3 className="title">4장 계약당사자의 의무</h3>
                        <ul>
                          <li>
                            <h4 className="subTitle">제14조 (회사의 의무)</h4>
                            <p className="contents">
                              회사는 서비스 제공 및 보안과 관련된 설비를
                              지속적이고, 안정적인 서비스 제공에 적합하도록
                              유지, 점검 또는 복구 등의 조치를 성실히 이행하여야
                              합니다.
                            </p>
                            <p className="contents">
                              회사는 관련법과 본 약관이 금지하거나 미풍양속에
                              반하는 행위를 하지 않으며, 계속적이고 안정적으로
                              서비스를 제공하기 위하여 최선을 다하여 노력합니다.
                            </p>
                            <p className="contents">
                              회사는 이용자가 안전하게 서비스를 이용할 수 있도록
                              개인정보보호를 위해 보안시스템을 갖추어야 하며
                              "개인정보처리방침"을 공시하고 준수하며, 회원의
                              개인정보를 본인의 승낙 없이 제3자에게 누설,
                              배포하지 않고, 이를 보호하기 위하여 노력합니다.
                            </p>
                            <p className="contents">
                              회사는 서비스이용과 관련하여 회원으로부터 제기된
                              의견이나 불만이 정당하다고 인정할 경우에는 이를
                              처리하여야 합니다. 회원이 제기한 의견이나
                              불만사항에 대해서는 게시판을 활용하거나 e-mail
                              등을 통하여 회원에게 처리 일정, 과정 및 결과를
                              전달합니다.
                            </p>
                            <p className="contents">
                              회사가 제공하는 서비스로 인하여 회원에게 손해가
                              발생한 경우 그러한 손해가 회사의 고의나 과실에
                              의해 발생한 경우에 한하여 회사에서 책임을
                              부담하며, 그 책임의 범위는 통상손해에 한합니다.
                            </p>
                            <p className="contents">
                              회사는 회원이 수신 동의를 하지 않은 영리 목적의
                              광고성 e-mail 등을 발송하지 아니합니다.
                            </p>
                            <p className="contents">
                              회사는 "정보통신망 이용촉진 및 정보보호에 관한
                              법률", "통신비밀보호법", "전기통신사업법 " 등
                              서비스의 운영, 유지와 관련 있는 법규를 준수합니다.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">제15조 (회원의 의무)</h4>
                            <p className="contents">
                              회원은 다음 행위를 하여서는 안됩니다.
                            </p>
                            <ul>
                              <li>
                                <p className="contents">
                                  1) 다른 회원의 이메일 및 비밀번호를 도용하여
                                  부당하게 서비스를 이용하거나, 정보를 도용하는
                                  행위
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  2) 타인의 계좌번호 및 신용카드번호 등 타인의
                                  허락 없이 타인의 결제정보를 이용하여 회사의
                                  유료 서비스를 이용하는 행위
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  3) 회사가 게시한 정보를 변경하는 행위
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  4) 회사가 정한 정보 이외의 정보(컴퓨터
                                  프로그램 등) 등을 송신 또는 게시하는 행위
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  5) 회사와 기타 제3자의 저작권 등 지적재산권을
                                  침해하는 행위
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  6) 회사 및 기타 제3자의 명예를 손상시키거나
                                  업무를 방해하는 행위
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  7) 회사의 동의 없이 영리를 목적으로 서비스를
                                  사용하는 행위
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  8) 회사의 직원이나 서비스의 관리자를
                                  가장하거나 사칭하여 또는 타인의 명의를
                                  도용하여 글을 게시하거나 메일을 발송하는 행위
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  9) 서비스와 관련된 설비의 오동작이나 정보 등의
                                  파괴 및 혼란을 유발시키는 컴퓨터 바이러스,
                                  기타 다른 컴퓨터 코드, 파일, 프로그램 자료를
                                  등록 또는 유포하는 행위
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  10) 회사가 제공하는 소프트웨어 등을 개작하거나
                                  리버스 엔지니어링, 디컴파일, 디스어셈블 하는
                                  행위
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  11) 다른 회원의 개인정보를 그 동의 없이 수집,
                                  저장, 공개하는 행위
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  12) 기타 불법적이거나 부당한 행위
                                </p>
                              </li>
                            </ul>
                            <p className="contents">
                              회원은 관계 법령, 본 약관의 규정, 이용안내 및
                              서비스상에 공지한 주의사항, 회사가 통지하는 사항
                              등을 준수하여야 하며, 기타 회사의 업무에 방해되는
                              행위를 하여서는 아니 됩니다.
                            </p>
                            <p className="contents">
                              회원은 서비스의 이용권한, 기타 서비스 이용계약상의
                              지위를 타인에게 양도, 증여할 수 없으며 이를 담보로
                              제공할 수 없습니다.
                            </p>
                            <p className="contents">
                              회원은 제7조(회원의 관리책임)에서 명시한
                              비밀번호를 철저히 관리하여야 합니다. 관리소홀,
                              부정사용 등에 의하여 발생하는 모든 결과에 대한
                              책임은 회원 본인이 부담하며, 회사는 이에 대한
                              어떠한 책임도 부담하지 않습니다.
                            </p>
                            <p className="contents">
                              민법상 미성년자인 회원이 유료 서비스를 이용 할
                              경우 미성년자인 회원은 결제 전 법정대리인의 동의를
                              얻어야 합니다.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              제16조 (회원에 대한 통지)
                            </h4>
                            <p className="contents">
                              회사가 회원에 대한 통지를 하는 경우 본 약관에 별도
                              규정이 없는 "홈페이지" 공자사항을 통해 할 수
                              있습니다.
                            </p>
                            <p className="contents">
                              회사는 불특정 다수 회원에 대한 통지의 경우
                              "홈페이지" 등에 게시함으로써 개별 통지에 갈음할 수
                              있습니다.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              제17조 (서비스 이용 해지)
                            </h4>
                            <p className="contents">
                              회원이 이용계약을 해지하고자 하는 때에는 회원
                              본인이 사이트 내에 해지신청(탈퇴신청) 메뉴 또는
                              해지방법에 대한 안내를 통해 해지를 신청할 수
                              있습니다.
                            </p>
                            <p className="contents">
                              회사는 등록 해지신청이 접수되면 회원이 원하는 시점
                              이전에 해당 회원의 서비스 이용을 해지하여야
                              합니다.
                            </p>
                            <p className="contents">
                              회원이 계약을 해지할 경우, 관련법 및
                              개인정보처리방침에 따라 회사가 회원정보를 보유하는
                              경우를 제외하고는 해지 즉시 회원의 모든 데이터는
                              소멸됩니다.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              제18조 (서비스 이용 제한)
                            </h4>
                            <p className="contents">
                              회사는 회원이 본 약관 및 개별서비스 이용약관을
                              위반한 경우 경고, 일시적 이용정지, 영구적 이용정지
                              등의 단계로 서비스 이용을 제한하거나 이용계약을
                              해지할 수 있습니다.
                            </p>
                            <p className="contents">
                              회원은 제1항에 따른 서비스 이용정지 기타 서비스
                              이용과 관련된 이용제한에 대해 회사가 정한 절차에
                              따라 이의신청을 할 수 있으며, 회사는 회원의
                              이의신청이 정당하다고 판단되는 경우 즉시 서비스
                              이용을 재개합니다.
                            </p>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <h3 className="title">5장 기타</h3>
                        <ul>
                          <li>
                            <h4 className="subTitle">제19조 (손해 배상)</h4>
                            <p className="contents">
                              회원이 본 약관의 규정을 위반함으로 인하여 회사에
                              손해가 발생하게 되는 경우, 본 약관을 위반한 회원은
                              회사에 발생하는 모든 손해를 배상하여야 합니다.
                            </p>
                            <p className="contents">
                              회원이 서비스를 이용하는 과정에서 행한 불법행위나
                              본 약관 위반행위로 인하여 회사가 당해 회원 이외의
                              제3자로부터 손해배상 청구 또는 소송을 비롯한 각종
                              이의제기를 받는 경우 당해 회원은 자신의 책임과
                              비용으로 회사를 면책 시켜야 하며, 회사가 면책되지
                              못한 경우 당해 회원은 그로 인하여 회사에 발생한
                              모든 손해를 배상하여야 합니다.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">제20조 (면책사항)</h4>
                            <p className="contents">
                              회사는 천재지변 또는 이에 준하는 불가항력으로
                              인하여 서비스를 제공할 수 없는 경우에는 서비스
                              제공에 관한 책임이 면책됩니다.
                            </p>
                            <p className="contents">
                              회사는 회원의 귀책사유로 인한 서비스의 이용장애에
                              대하여 책임을 지지 않습니다.
                            </p>
                            <p className="contents">
                              회사는 회원이 서비스를 이용하여 기대하는 수익을
                              상실한 것에 대하여 책임을 지지 않으며 그 밖에
                              서비스를 통하여 얻은 자료로 인한 손해 등에
                              대하여도 책임을 지지 않습니다. 회사는 회원이
                              사이트에 게재한 게시물의 정확성 등 내용에 대하여는
                              책임을 지지 않습니다.
                            </p>
                            <p className="contents">
                              회사는 회원 상호간 또는 회원과 제3자 상호간에
                              서비스를 매개로 발생한 분쟁에 대해서는 개입할
                              의무가 없으며 이로 인한 손해를 배상할 책임도
                              없습니다.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              제21조 (분쟁 조정 및 관할법원)
                            </h4>
                            <p className="contents">
                              회사와 회원 간 제기된 소송은 대한민국법을
                              준거법으로 합니다.
                            </p>
                            <p className="contents">
                              서비스 이용과 관련하여 발생한 분쟁에 대한 소송을
                              제기하는 경우에는 민사소송법상의 법원을
                              관할법원으로 합니다.
                            </p>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <h4 className="subTitle">부칙</h4>
                        <p className="contents">
                          [시행일] 본 이용약관은 2023년 06월 01일부터
                          적용됩니다.
                        </p>
                        <p className="contents">
                          - 공고일자 : 2023년 06월 01일
                        </p>
                        <p className="contents">
                          - 시행일자 : 2023년 06월 01일
                        </p>
                      </li>
                    </ul> */}
                    {/* <button
                      type="button"
                      onClick={() => {
                        showEcoHistoryContent();
                        moveScrollTop();
                      }}
                      className="btn btn-green height h-40 mg mt-10 mr-20"
                    >
                      <span className="policyHistory">
                        변경 전 Wrapsody Eco Cloud 이용약관 보기 &gt;
                      </span>
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        showWrapsodyHistoryContent();
                        moveScrollTop();
                      }}
                      className="btn btn-green height h-40 mg mt-10"
                    >
                      <span className="policyHistory">
                        변경 전 Wrapsody Cloud 이용약관 보기 &gt;
                      </span>
                    </button> */}
                  </div>
                )}

              {!showEcoPolicyHistory &&
                !showWrapsodyPolicyHistory &&
                language === "en" && (
                  <div className="modalWindow">
                    <ul>
                      <li>
                        <h3 className="title">Chapter 1 General Provisions</h3>
                        <ul>
                          <li>
                            <h4 className="subTitle">Article 1 (Purpose)</h4>
                            <p className="contents">
                              These provisions aim to prescribe Fasoo Co., Ltd
                              (hereafter "the Company") and its users' rights,
                              obligations, and responsibilities in using wired
                              and wireless internet service, Wrapsody & Wrapsody
                              eCo services. (hereafter "the Service").
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">Article 2 (Definition)</h4>
                            <p className="contents">
                              Terms used in this Terms of Service have the
                              following meanings:
                            </p>
                            <ul>
                              <li>
                                <p className="contents">
                                  "Service": All goods and services provided by
                                  the Company to members through devices
                                  (including PCs, mobile devices such as smart
                                  phones and other various wired and wireless
                                  devices) or programs.
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  "Member": A customer consents to these Terms
                                  of Service and uses the Service provided by
                                  the Company
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  "Site": Services including web-based wired and
                                  wireless homepage (http://*.wrapsody.com,
                                  http://*.wrapsodyeco.com).
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  Application: A program installed on supported
                                  portable devices of the service.
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  ID: An e-mail address entered by a member to
                                  distinguish an identity or using services.
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  Password: A combination of 8 or more letters,
                                  numbers, or special characters which a member
                                  provides and registers in order to verify a
                                  member's identity and to protect
                                  confidentiality.
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  Posts: All digital content including document
                                  members register on the Wrapsody & Wrapsody
                                  eCo sites.
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  Operator: A person designated by the Company
                                  for overall management and smooth operation of
                                  the service.
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  Paid Service: An optional service that allows
                                  users to select the service provided by the
                                  Company according to their needs.
                                </p>
                              </li>
                            </ul>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              Article 3 (Effectiveness and Amendment of
                              Provisions)
                            </h4>
                            <p className="contents">
                              This Terms of Service is effective for all members
                              who want to use the service.
                            </p>
                            <p className="contents">
                              These Terms of Service can be viewed by members
                              when signing up for the service, and the Company
                              publishes these Terms of Service on the website
                              and application to allow Users to view the Terms
                              of Service whenever they want.
                            </p>
                            <p className="contents">
                              The Company may revise these Terms of Service to
                              the extent that they do not violate related laws
                              such as the "Act on the Stability of Terms and
                              Conditions", "Act on Consumer Protection such as
                              E-Commerce", "Act on Promotion of Information and
                              Communications Network Utilization and Information
                              Protection Rules", "Online Digital Content
                              Industry Development Act", and the "Consumer
                              Standards Act".
                            </p>
                            <p className="contents">
                              The company may change these Terms of Service if
                              deemed necessary. In the event of amending Terms
                              of Service, the Company shall notify users of the
                              causes of amendment and applied from fifteen (15)
                              days prior to date such amendments will be in
                              effect to the day before applied date.
                            </p>
                            <p className="contents">
                              In amending these Terms of Service, the Company
                              will notify or announce the revised Terms of
                              Service in accordance with paragraph 3 and confirm
                              whether a member consents to the application of
                              the amended Terms of Service after their
                              publication; provided, however, a User may be
                              deemed to have consented to the amended Terms of
                              Service if the User fails to express consent or
                              disagreement until their effective date and the
                              Company has published together with the amended
                              Terms of Service that such failure shall be deemed
                              as the User's consent
                            </p>
                            <p className="contents">
                              If a User disagrees to the application of the
                              revised/amended Terms of Service, the User may
                              withdraw from the Service and terminate the
                              contract.
                            </p>
                            <p className="contents">
                              The members have a duty to monitor changes in
                              Terms of Service carefully, and the Company is not
                              responsible for the member's damage caused by
                              ignorance of the changed Terms of Service.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              Article 4 (Other terms and conditions)
                            </h4>
                            <p className="contents">
                              Any matters that are not prescribed in this Terms
                              of Service shall be subject to the relevant laws
                              and regulations.
                            </p>
                            <p className="contents">
                              The Company, if deemed necessary, can define the
                              Terms of Service for the individual services, and
                              operation policies. In case of conflict between
                              these Terms of Service and the Terms of Service
                              for particular services or operation policies, the
                              rules set forth by the Company shall take
                              precedence.
                            </p>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <h3 className="title">
                          Chapter 2 Service Use Contract
                        </h3>
                        <ul>
                          <li>
                            <h4 className="subTitle">
                              Article 5 (Establishment of Contract of Use)
                            </h4>
                            <p className="contents">
                              The contact of use shall come into effect when the
                              Company accepts a membership request after the
                              user completes the application form set by the
                              Company and check "I agree" to this Terms of
                              Service and the "Privacy Policy".
                            </p>
                            <p className="contents">
                              When the application for sign-up has been
                              completed, the Company must confirm if the
                              requirements are met and approve it without delay.
                            </p>
                            <p className="contents">
                              When the applicant for membership sign-up selects
                              "I agree" to all items and fills out the
                              application form, it is regarded that he or she
                              has read these Terms of Service and Privacy Policy
                              and agrees to follow the various policies that the
                              company operates to provide the Service and
                              frequent notices from the company.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              Article 6 (Suspension and Refusal of User
                              Contract)
                            </h4>
                            <p className="contents">
                              The Company may suspend acceptance or terminate
                              the use contract afterwards for the following
                              reasons:
                            </p>
                            <ul>
                              <li>
                                <p className="contents">
                                  1) In cases where an applicant has written
                                  false information in the application form
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  2) In cases where an applicant has used
                                  somebody else´s e-mail for verification.
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  3) In cases where an applicant for membership
                                  has lost the qualification for membership in
                                  the past according to the Terms of Service.
                                  However, this does not apply if he/she has
                                  obtained the permission of reapplication for
                                  membership from the Company.
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  4) In cases where it is impossible to approve
                                  due to a reason attributable to the user or
                                  the user has applied for the membership in
                                  violation of other regulated matters
                                </p>
                              </li>
                            </ul>
                            <p className="contents">
                              The Company may request the verification of the
                              user's real name through a specialized agency and
                              user authentication for the application according
                              to Paragraph 1.
                            </p>
                            <p className="contents">
                              The Company may defer approval of registration for
                              the following reasons:
                            </p>
                            <ul>
                              <li>
                                <p className="contents">
                                  1) In cases when there are no available
                                  service-related facilities
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  2) In case when a technical issue exists to
                                  provide the Service
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  3) In case where it is deemed necessary
                                  financially and technically by the company
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  4) In case when it is difficult to approve for
                                  other reasons
                                </p>
                              </li>
                            </ul>
                            <p className="contents">
                              If approval for the application for membership
                              according is not given or deferred according to
                              Paragraphs 1 and 3, the Company shall inform the
                              applicant for membership of the refusal.
                            </p>
                            <p className="contents">
                              The use agreement is concluded when the Company
                              marks the subscription complete on the application
                              procedure.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              Article 7 (Obligation to Manage Members)
                            </h4>
                            <p className="contents">
                              The member shall be responsible for any damages
                              caused by the member's intention or negligence in
                              managing his/ her account ID and password to use
                              the Service. However, if the Company's intention
                              or negligence caused any disadvantages, the
                              Company take the responsibilities.
                            </p>
                            <p className="contents">
                              If the user recognizes that the ID and password
                              are used by a third party, the user should
                              immediately take measures including changing the
                              password, and notify the Company and follow the
                              instructions of the company
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              Article 8 (Obligation to Protect Personal
                              Information)
                            </h4>
                            <p className="contents">
                              The Company does not collect any personal
                              information except for the ID (e-mail) and
                              password that are basically required to provide
                              the Service.
                            </p>
                            <p className="contents">
                              The Company can use the ID entered by the member
                              when signing up except for the password to provide
                              services and to indicate the source of data.
                            </p>
                            <p className="contents">
                              The Company tries to protect the password entered
                              by the member when registering as a member through
                              high-level encryption so that the Company and
                              third parties cannot detect.
                            </p>
                            <p className="contents">
                              The Company's "Privacy Policy" is not applied to
                              other websites (that are not operated by the
                              Company) linked to the Service.
                            </p>
                            <p className="contents">
                              The Company can entrust some or all of these tasks
                              to a company selected by the Company if necessary.
                              It will notify in the "Privacy Policy" when
                              entrusting tasks related to handling and managing
                              member information or service operation
                              information.
                            </p>
                            <p className="contents">
                              The Company is not responsible for the information
                              disclosure due to a member's fault can provide
                              members' information in the following cases.
                            </p>
                            <ul>
                              <li>
                                <p className="contents">
                                  1) When an investigative agency or other
                                  governmental agency requests to provide
                                  information as a member violates applicable
                                  laws while using the Service.
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  2) When it is necessary for information
                                  protection activities such as confirmation of
                                  a violation of the legislation by a member and
                                  fraud act, including violation of these Terms
                                  of Service.
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  3) When required by other laws
                                </p>
                              </li>
                            </ul>
                            <p className="contents">
                              The Company tries to protect members' personal
                              information in accordance with related laws and
                              regulations, such as the "Information and
                              Communication Network Act". Regarding the
                              protection and use of personal information, the
                              relevant laws and the Company's personal
                              information processing policy is applied. However,
                              However, the Company's privacy policy does not
                              apply to linked sites other than the Company's
                              official website.
                            </p>
                            <p className="contents">
                              The Company may request the minimum information
                              (name, address, phone number) required for payment
                              of products, and does not store financial
                              information related to the payment.
                            </p>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <h3 className="title">Chapter 3 Use of Service</h3>
                        <ul>
                          <li>
                            <h4 className="subTitle">
                              Article 9 (Provision of Service)
                            </h4>
                            <p className="contents">
                              The Company provides the following services to
                              members:
                            </p>
                            <ul>
                              <li>
                                <p className="contents">
                                  1) Wrapsody & Wrapsody eCo (Editing and
                                  sharing service for encrypted documents)
                                </p>
                              </li>
                            </ul>
                            <p className="contents">
                              Members can use the service from the time the
                              company approves the application of use. The
                              company will start to provide the service from the
                              time of approval. However, paid service can be
                              available immediately after the company confirms
                              the payment of fees
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              Article 10 (Use of the Service)
                            </h4>
                            <p className="contents">
                              The services are available 24 hours a day, seven
                              days a week, 365 days a year. The Company may
                              separately set the service hours for all or part
                              of the services provided.
                            </p>
                            <p className="contents">
                              The company can conduct regular and irregular
                              inspections if necessary for the provision of
                              services, and the inspection time is as announced
                              on the service provision screen.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              Article 11 (Changes and Suspensions of the
                              Service)
                            </h4>
                            <p className="contents">
                              The company may notify the member of the contents
                              and the date of provision of the Service to be
                              changed in the manner specified in Article 20 and
                              can provide the modified service.
                            </p>
                            <p className="contents">
                              The Company may limit or suspend the use of the
                              Service in the following cases.
                            </p>
                            <ul>
                              <li>
                                <p className="contents">
                                  1) When a member interferes with the Company's
                                  sales activities
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  2) When regular service is not available due
                                  to heavy traffic
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  3) When a telecommunication service provider
                                  prescribed by the Telecommunications Business
                                  Act stops telecommunication services
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  4) When regular service is not possible due to
                                  infrastructure failure or heavy traffic.
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  5) When the Company deems that it is
                                  inappropriate to continue providing services
                                  due to other serious reasons.
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  6) When there are force majeure reasons such
                                  as natural disasters or national emergencies.
                                </p>
                              </li>
                            </ul>
                            <p className="contents">
                              The Company shall notify the member as prescribed
                              in Article 21 when suspending the Service
                              according to Paragraph 2. However, this is not the
                              case if advance notice is not possible due to
                              service interruption (disruption of the disk
                              without operator's intention or negligence, system
                              down, etc.) due to reasons beyond the Company's
                              control.
                            </p>
                            <p className="contents">
                              The Company is not responsible for any problems
                              caused by the change or suspension of the Service.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              Article 12 (Provision of information and Insertion
                              of Advertisement)
                            </h4>
                            <p className="contents">
                              Members might agree to be exposed to the
                              advertisements while using the Service.{" "}
                            </p>
                            <p className="contents">
                              The Company can provide advertisements to service
                              users.{" "}
                            </p>
                            <p className="contents">
                              It is entirely a matter between the member and the
                              advertiser when a member communicates or trades by
                              using advertising on the service or participating
                              in the advertiser's promotional activities through
                              the Service.
                            </p>
                            <p className="contents">
                              In the event of a dispute or other problem between
                              a member and an advertiser, the member and the
                              advertiser must settle it themselves, and the
                              Company does not take any responsibility in this
                              regard.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              Article 13 (Copyright of Post)
                            </h4>
                            <p className="contents">
                              The Company may not use the post for other
                              purposes without the consent of the posted member.
                            </p>
                            <p className="contents">
                              The Company shall not be civilly and criminally
                              liable even if the posts posted by the members in
                              the Service infringe on the copyrights and other
                              rights of others. If a member receives an
                              objection, such as a claim for damages because a
                              member has violated the copyright or other rights
                              of the other person, the members must make efforts
                              to indemnify the Company, and the member must bear
                              all damages caused to the Company.
                            </p>
                            <p className="contents">
                              The Company may delete the posts posted by members
                              if the member terminates the use contract and
                              withdraws from the site, or if the agreement is
                              terminated for a legitimate reason.
                            </p>
                            <p className="contents">
                              The copyright of the work created by the Company
                              belongs to the Company.
                            </p>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <h3 className="title">
                          Chapter 4 Obligation of Contracting Parties
                        </h3>
                        <ul>
                          <li>
                            <h4 className="subTitle">
                              Article 14 (Obligation of the Company)
                            </h4>
                            <p className="contents">
                              The Company must sincerely implement measures such
                              as maintenance, inspection, or restoration to
                              ensure that facilities related to service
                              provision and security are suitable to provide
                              continuous and stable service.
                            </p>
                            <p className="contents">
                              The Company does not conduct any activates that
                              are prohibited by the relevant laws and these
                              Terms and Services or contrary to the customs, and
                              does its best to continuously and reliably provide
                              services.
                            </p>
                            <p className="contents">
                              The company must have a security system to protect
                              personal information so that users can safely use
                              the service, announce and comply with the "Privacy
                              Policy", and try to protect member's personal
                              information without leaking or distributing to
                              third parties without their consent.
                            </p>
                            <p className="contents">
                              The company must handle the opinions or complaints
                              raised by members regarding the use of the service
                              when it is justified. When an opinions or a
                              complaint is raised by a member, processing
                              schedule, process, and results should be notified
                              to the member via bulletin board or e-mail.
                            </p>
                            <p className="contents">
                              If the member suffers damages due to the services
                              provided by the company due to the services
                              provided by the company, the company bears the
                              responsibility only if such damage is caused by
                              the company's intention or negligence, and the
                              scope of the responsibility is limited to ordinary
                              damages.
                            </p>
                            <p className="contents">
                              The company does not send commercial e-mails for
                              commercial purposes without the member's consent
                              to receive them.
                            </p>
                            <p className="contents">
                              The company complies with laws and regulations
                              related to the operation and maintenance of
                              services such as the "Act on Promotion of
                              Information and Communications Network Utilization
                              and Information Protection", "Communication Secret
                              Protection Act", and "Telecommunications Business
                              Act".
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              Article 15 (Obligation of the Members)
                            </h4>
                            <p className="contents">
                              The members must perform none of the following
                              activities.
                            </p>
                            <ul>
                              <li>
                                <p className="contents">
                                  1) Inappropriately or unjustifiably use the
                                  service by stealing other member's email and
                                  password, or steal information
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  2) Act of using the company's paid service by
                                  using payment information of others without
                                  the permission of others, such as account
                                  numbers and credit card numbers of others
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  3) Act of Changing the information posted by
                                  the company
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  4) Sending or posting information (computer
                                  programs, etc.) other than the information
                                  specified by the company
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  5) Violate other rights of the Company or a
                                  third party including copyright
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  6) Defame or injure reputation of the company
                                  or a third party, or interrupt business
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  7) The act of using the service for profit
                                  without the consent of the company
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  8) Posting a post or sending an e-mail by
                                  impersonating or impersonating a manager of a
                                  company employee or service, or stealing
                                  another person's name
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  9) Act of posting or distributing any material
                                  that contains software virus, other computer
                                  code, file or program designed to disrupt or
                                  destroy normal operation of the equipment
                                  related to the service.
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  10) Act of re-engineering, reverse
                                  engineering, decompiling, and disassembling
                                  software provided by the company
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  11) Collect, store and/or disclose other
                                  member's personal information
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  12) Other Illegal and unfair act
                                </p>
                              </li>
                            </ul>
                            <p className="contents">
                              Members must comply with relevant laws, provisions
                              of these Terms and Services, notice of use and
                              notices on the service, and notices of the
                              company, and shall not engage in any other act
                              that interferes with the company's business.
                            </p>
                            <p className="contents">
                              Members shall neither transfer nor grant their
                              rights to use and legal status hereby, nor
                              impignorate the foregoing rights and status
                            </p>
                            <p className="contents">
                              Members must thoroughly manage the password
                              specified in Article 7 (Obligation of the
                              Members). he member is responsible for all the
                              consequences caused by negligence, misuse, etc.,
                              and the company does not take any responsibility
                              for it.
                            </p>
                            <p className="contents">
                              Under the Civil Law, if a member who is a minor
                              uses the paid service, the member who is a minor
                              must obtain the consent of the legal
                              representative before payment.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              Article 16 (Notification and Announcement to the
                              Members)
                            </h4>
                            <p className="contents">
                              If the company notifies the member, it can be done
                              through the "homepage" notice that does not have a
                              separate regulation in this Terms of Service.
                            </p>
                            <p className="contents">
                              In the case of notice to multiple unspecified
                              members, the company can replace individual
                              notices by posting it on "homepage".
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              Article 17 (Termination of the Service)
                            </h4>
                            <p className="contents">
                              When a member wants to terminate the contract of
                              use, the member himself/herself can apply for
                              termination through the menu of cancellation
                              request (withdrawal request) on the site or
                              information on how to cancel.
                            </p>
                            <p className="contents">
                              When the company receives an application for
                              cancellation of registration, the company must
                              terminate the use of the member's service before
                              the point the member wants.
                            </p>
                            <p className="contents">
                              When a member terminates the contract, all data of
                              the member is destroyed immediately upon
                              termination, except when the company holds the
                              member information in accordance with applicable
                              laws and personal information processing policies.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              Article 18 (Use Restrictions of the Service)
                            </h4>
                            <p className="contents">
                              In the event that a member violates these Terms of
                              Service or Terms of Service of individual
                              services, the Company may limit the use of the
                              service at the stages of warning, temporary
                              suspension, and permanent suspension, or terminate
                              the use contract.
                            </p>
                            <p className="contents">
                              The member can make an objection to the use of the
                              service pursuant to Paragraph 1 or use
                              restrictions related to the use of the service in
                              accordance with the procedures set by the Company,
                              and the company immediately resumes using the
                              service when it is deemed that the member's
                              objection is justified.
                            </p>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <h3 className="title">Chapter 5 Others</h3>
                        <ul>
                          <li>
                            <h4 className="subTitle">
                              Article 19 (Indemnification for Damage)
                            </h4>
                            <p className="contents">
                              If a member causes damages to the company due to
                              violation of the provisions of these Terms of
                              Services, the member who violates these Terms of
                              Services shall compensate all damages to the
                              company.
                            </p>
                            <p className="contents">
                              In the event that the Company receives various
                              complaints including claims for damages or
                              lawsuits from third parties other than the member
                              due to illegal acts or violations of these terms
                              and conditions in the process of using the
                              service, the member is responsible for the Company
                              at his/her own responsibility and expense. The
                              Company must indemnify and if the company fails to
                              indemnify, the member must compensate for any
                              damages caused to the Company.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              Article 20 (Disclaimer)
                            </h4>
                            <p className="contents">
                              If the Company is unable to provide the service
                              due to a natural disaster or equivalent force
                              majeure, the Company is exempted from liability
                              for Service provision.
                            </p>
                            <p className="contents">
                              The company is not responsible for the failure to
                              use the service due to a member's fault.
                            </p>
                            <p className="contents">
                              The Company shall not be held responsible for not
                              meeting customers' expectations for profit through
                              the use of this Service, or loss or damage caused
                              by the Service. The Company is not responsible for
                              the content of posts posted in the site by members
                              regarding accuracy.
                            </p>
                            <p className="contents">
                              The company is not obliged to intervene in
                              disputes between members or between a member and a
                              third party that arose from the service as a
                              medium, and is not responsible for reimbursing
                              damages.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              Article 21 (Dispute Settlement and Competent
                              Jurisdiction)
                            </h4>
                            <p className="contents">
                              When a lawsuit is filed against a dispute between
                              the Company and a member, Korean law shall apply.
                            </p>
                            <p className="contents">
                              If the Company file a lawsuit in relation to the
                              use of the Service, the court under the Civil
                              Procedure Act shall be the competent court.
                            </p>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <h4 className="subTitle">Additional Terms</h4>
                        <p className="contents">
                          [Enforcement Date] These Terms of Service takes effect
                          on June 1, 2023.
                        </p>
                        <p className="contents">
                          - Notification Date: June 1, 2023
                        </p>
                        <p className="contents">
                          - Enforcement Date: June 1, 2023
                        </p>
                      </li>
                    </ul>
                    {/* <button
                      type="button"
                      onClick={() => {
                        showEcoHistoryContent();
                        moveScrollTop();
                      }}
                      className="btn btn-green height h-40 mg mt-10 mr-20"
                    >
                      <span className="policyHistory">
                        See past terms of Wrapsody eCo service &gt;
                      </span>
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        showWrapsodyHistoryContent();
                        moveScrollTop();
                      }}
                      className="btn btn-green height h-40 mg mt-10"
                    >
                      <span className="policyHistory">
                        See past terms of Wrapsody service &gt;
                      </span>
                    </button> */}
                  </div>
                )}
            </div>

            {/* 개인정보처리방침 */}
            <div
              className={`tab_content ${tabTarget === "tab2" ? "active" : ""}`}
            >
              {/* {console.log("showEcoPolicyHistory : ", showEcoPolicyHistory)}
              {console.log(
                "showWrapsodyPolicyHistory : ",
                showWrapsodyPolicyHistory
              )} */}

              {/* {showEcoPolicyHistory && (
                <EcoPolicyComponent
                  // showPolicy={showPolicy}
                  // showEcoPolicyHistory={showEcoPolicyHistory}
                  hideEcoHistoryContent={hideEcoHistoryContent}
                  // handleClickTab={handleClickTab}
                  // cancelButton={cancelButton}
                  tabTarget={tabTarget}
                />
              )} */}

              {/* {showWrapsodyPolicyHistory && (
                <WrapsodyPolicyComponent
                  // showPolicy={showPolicy}
                  // showWrapsodyPolicyHistory={showWrapsodyPolicyHistory}
                  hideWrapsodyHistoryContent={hideWrapsodyHistoryContent}
                  // handleClickTab={handleClickTab}
                  // cancelButton={cancelButton}
                  tabTarget={tabTarget}
                />
              )} */}

              {!showEcoPolicyHistory &&
                !showWrapsodyPolicyHistory &&
                language === "ko" && (
                  <div className="modalWindow">
                    <ul>
                      <li>
                        <h3 className="title">
                          주식회사 파수 개인정보 처리방침
                        </h3>
                        <p className="contents">
                          ‘파수’는 (이하 ‘회사’는) 고객님의 개인정보를
                          중요시하며, “정보통신망 이용촉진 및 정보보호”에 관한
                          법률을 준수하고 있습니다. 회사는 개인정보처리방침을
                          통하여 고객님께서 제공하시는 개인정보가 어떠한 용도와
                          방식으로 이용되고 있으며, 개인정보보호를 위해 어떠한
                          조치가 취해지고 있는지 알려드립니다. 회사는
                          개인정보처리방침을 개정하는 경우 웹사이트
                          공지사항(또는 개별공지)을 통하여 공지할 것입니다. 본
                          방침은 2014년 3월 7일부터 시행됩니다.
                        </p>
                      </li>
                      <li>
                        <h3 className="title">개인정보의 수집 및 이용 목적</h3>
                        <p className="contents">
                          수집하는 개인정보 항목 회사는 상담, 서비스 신청 등을
                          위해 아래와 같은 개인정보를 수집하고 있습니다. 회사는
                          수집한 개인정보를 다음의 목적을 위해 활용합니다.
                        </p>
                        <ul>
                          <li>
                            <ul>
                              <li className="contents">
                                ◾ 수집항목 : 이름 , 휴대전화번호 , 회사전화번호
                                , 이메일 , 회사명 , 직책
                              </li>
                              <li className="contents">
                                ◾ 개인정보 수집방법 : 홈페이지(상담폼,
                                브로슈어다운로드, 뉴스레터 구독신청, 이벤트
                                프로모션 신청)
                              </li>
                              <li className="contents">
                                ◾ 정보이용 및 이벤트 신청에 따른 본인확인 ,
                                개인 식별 , 불만처리 등 민원처리
                              </li>
                              <li className="contents">
                                ◾ 마케팅 및 광고에 활용 이벤트 등 광고성 정보
                                전달 , 접속 빈도 파악 또는 회원의 서비스 이용에
                                대한 통계
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <h3 className="title">개인정보의 보유 및 이용기간</h3>
                        <p className="contents">
                          회사는 개인정보 수집 및 이용목적이 달성된 후에는 예외
                          없이 해당 정보를 지체 없이 파기합니다.
                        </p>
                      </li>
                      <li>
                        <h3 className="title">개인정보의 파기절차 및 방법</h3>
                        <p>
                          회사는 원칙적으로 개인정보 수집 및 이용목적이 달성된
                          후에는 해당 정보를 지체없이 파기합니다. 파기절차 및
                          방법은 다음과 같습니다.
                        </p>
                        <ul>
                          <li className="contents">
                            ◾ 제품 정보이용을 위해 입력하신 개인정보는 목적이
                            달성된 후 별도의 DB로 옮겨져(종이의 경우 별도의
                            서류함) 내부 방침 및 기타 관련 법령에 의한 정보보호
                            사유에 따라(보유 및 이용기간 참조) 일정 기간 저장된
                            후 파기되어집니다. 별도 DB로 옮겨진 개인정보는
                            법률에 의한 경우가 아니고서는 보유되어지는 이외의
                            다른 목적으로 이용되지 않습니다.
                          </li>
                          <li className="contents">
                            ◾ 파기방법 – DB삭제 방법으로 파기합니다.
                          </li>
                        </ul>
                      </li>
                      <li>
                        <h3 className="title">개인정보 제공</h3>
                        <ul>
                          <li>
                            <p>
                              회사는 이용자의 개인정보를 원칙적으로 외부에
                              제공하지 않습니다. 다만, 아래의 경우에는 예외로
                              합니다.
                            </p>
                            <ul>
                              <li className="contents">
                                ◾ 이용자들이 사전에 동의한 경우
                              </li>
                              <li className="contents">
                                ◾ 법령의 규정에 의거하거나, 수사 목적으로
                                법령에 정해진 절차와 방법에 따라 수사기관의
                                요구가 있는 경우
                              </li>
                            </ul>
                          </li>
                          <li>
                            <h4 className="subTitle">수집한 개인정보의 위탁</h4>
                            <p className="contents">
                              이용자 및 법정 대리인은 언제든지 등록되어 있는
                              자신 혹은 당해 만 14세 미만 아동의 개인정보를
                              조회하거나 수정할 수 있으며 가입해지를 요청할 수도
                              있습니다. 이용자 혹은 만 14세 미만 아동의 개인정보
                              조회 · 수정을 위해서는 ‘개인정보변경'(또는
                              ‘회원정보수정’ 등)을 가입해지(동의철회)를 위해서는
                              “회원탈퇴”를 클릭 하여 본인 확인 절차를 거치신 후
                              직접 열람, 정정 또는 탈퇴가 가능합니다. 혹은
                              개인정보관리책임자에게 서면, 전화 또는 이메일로
                              연락하시면 지체없이 조 치하겠습니다. 귀하가
                              개인정보의 오류에 대한 정정을 요청하신 경우에는
                              정정을 완료하기 전까 지 당해 개인정보를 이용 또는
                              제공하지 않습니다. 또한 잘못된 개인정보를 제3자
                              에게 이미 제공한 경우에는 정정 처리결과를
                              제3자에게 지체없이 통지하여 정정이 이루어지도록
                              하겠습니다. 파수는 이용자 혹은 법정 대리인의
                              요청에 의해 해지 또는 삭제된 개인정보는 “파수가
                              수집하는 개인정보의 보유 및 이용기간”에 명시된
                              바에 따라 처리하고 그 외의 용도로 열람 또는 이용할
                              수 없도록 처리하고 있습니다.
                            </p>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <h3 className="title">
                          개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한
                          사항
                        </h3>
                        <p className="contents">
                          회사는 고객의 선호 사항 등을 기억해 서비스를
                          효율적으로 제공하기 위해 개인정보를 저장하고 조회하는
                          쿠키(Cookie, 이하 ‘쿠키’)를 설치하거나 운용할 수
                          있습니다. 회사는 고객이 웹 브라우저에 접속하면 고객의
                          브라우저에 저장된 쿠키의 내용을 읽고, 추가 정보를 찾아
                          이후 접속할 시 맞춤 서비스를 제공할 수 있습니다.
                          회사가 쿠키를 통해 수집한 고객의 정보는 아래 목적 등을
                          위해 사용될 수 있습니다.
                        </p>
                        <p className="contents">
                          – 고객의 관심 분야에 따라 차별화한 정보 제공
                          <br />
                          – 관심있게 둘러본 내용의 자취를 추적해 추후 접속 때
                          개인 맞춤 서비스 제공
                          <br />
                          – 고객들의 패턴을 분석해 서비스 개편 등의 척도로 활용
                          <br />
                        </p>
                        <p className="contents">
                          고객은 위 목적으로 운영되는 맞춤 서비스를 원치 않을
                          시, 쿠키의 저장을 거부할 수 있습니다.
                        </p>
                      </li>
                      <li>
                        <h3 className="title">개인정보에 관한 민원서비스</h3>
                        <ul>
                          <li>
                            <p className="contents">
                              회사는 고객의 개인정보를 보호하고 개인정보와
                              관련한 불만을 처리하기 위하여 아래와 같이 관련
                              부서 및 개인정보관리책임자를 지정하고 있습니다.
                            </p>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <h3 className="title">개인정보관리 책임자</h3>
                        <ul>
                          <li className="contents">◾ 책임자: 김용길 상무</li>
                          <li className="contents">
                            ◾ 연락처: kimyg@fasoo.com
                          </li>
                          <li className="contents">◾ 담당자 박현수 수석</li>
                          <li className="contents">
                            ◾ 연락처: hspark@fasoo.com
                          </li>
                        </ul>
                        <br />
                        <br />
                        <p>
                          귀하께서는 회사의 서비스를 이용하시며 발생하는 모든
                          개인정보보호 관련 민원을 개인정보관리책임자 혹은
                          담당부서로 신고하실 수 있습니다.
                        </p>
                        <br />
                      </li>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div>
                          <h3 className="subtitle">개인정보관리책임자</h3>
                          <ul>
                            <li className="contents">◾ 국번없이 118</li>
                            <li className="contents">◾ privacy.kisa.or.kr</li>
                          </ul>
                        </div>
                        <div>
                          <h3 className="subtitle">정보보호마크인증위원회</h3>
                          <ul>
                            <li className="contents">◾ 02-550-9531~2</li>
                            <li className="contents">◾ www.eprivacy.or.kr</li>
                          </ul>
                        </div>
                        <div>
                          <h3 className="subtitle">개인정보관리책임자</h3>
                          <ul>
                            <li className="contents">◾ 국번없이 1301</li>
                            <li className="contents">◾ www.spo.go.kr</li>
                          </ul>
                        </div>
                        <div>
                          <h3 className="subtitle">개인정보관리 책임자</h3>
                          <ul>
                            <li className="contents">◾ 국번없이 182</li>
                            <li className="contents">
                              ◾ 연락처: cyberbureau.police.go.kr
                            </li>
                          </ul>
                        </div>
                      </div>
                      <br />
                      {/* <button
                        type="button"
                        onClick={() => {
                          showEcoHistoryContent();
                          moveScrollTop();
                        }}
                        className="btn btn-green height h-40 mg mt-10 mr-20"
                      >
                        <span className="policyHistory">
                          변경 전 Wrapsody Eco Cloud 개인정보처리방침 보기 &gt;
                        </span>
                      </button>
                      <button
                        type="button"
                        onClick={() => {
                          showWrapsodyHistoryContent();
                          moveScrollTop();
                        }}
                        className="btn btn-green height h-40 mg mt-10"
                      >
                        <span className="policyHistory">
                          변경 전 Wrapsody Cloud 개인정보처리방침 보기 &gt;
                        </span>
                      </button> */}
                    </ul>
                  </div>
                )}

              {!showEcoPolicyHistory &&
                !showWrapsodyPolicyHistory &&
                language === "en" && (
                  <div className="inner modalWindow">
                    <ul>
                      <li>
                        <h3 className="title">1. General Provisions</h3>
                        <p className="contents">
                          Personal information is defined as information that
                          identifies an individual (including that which can be
                          identified by combining it with other information,
                          when it cannot identify an individual with the
                          relevant information alone) with items that are
                          included in the relevant information about an
                          individual, such as their name and resident
                          registration number.
                        </p>
                        <p className="contents">
                          Fasoo Co., Ltd ("the Company") takes customer
                          information protection first and closely observes all
                          domestic legislation, including the Act on Promotion
                          of Information and Communications Network Utilization
                          and Information Protection, etc. ("Information and
                          Communications Network Act") and Personal Information
                          Protection Act.
                        </p>
                        <p className="contents">
                          The Company's privacy policy provides information
                          regarding the purposes and uses of the personal
                          information provided by the customer and indicates the
                          kinds of measures that are taken to protect the
                          personal information through our privacy policy.
                        </p>
                        <p className="contents">
                          The Company reserves the right to change, amend or
                          modify this Privacy Policy of Wrapsody & Wrapsody eCo
                          Services ("the Services") in accordance with
                          applicable law, regulations, and policies, and, in
                          such case, the Company discloses the privacy policy on
                          the Company where the customer can find it with ease.
                        </p>
                      </li>
                      <li>
                        <h3 className="title">
                          2. Items of Collected Personal Information and Methods
                          of Collection
                        </h3>
                        <p className="contents">
                          The company collects and processes the following
                          personal information to provide basic services.
                        </p>
                        <ul>
                          <li>
                            <h4 className="subTitle">
                              ① Personal information to be collected
                            </h4>
                            <table>
                              <thead>
                                <tr>
                                  <th className="th">
                                    Information to be collected
                                  </th>
                                  <th className="th">Purpose of use</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td className="td">
                                    E-mail, name, service usage records, Service
                                    suspension records, Service termination
                                    records, IP information, access log, Paid
                                    plan subscription/ subscription history,
                                    billing/payment information and history
                                  </td>
                                  <td className="td">
                                    To secure communication channels to deliver
                                    service-related notifications, to confirm
                                    the customer's intention, and to handle
                                    complaints.
                                    <br />
                                    To guide new services/products regarding
                                    Wrapsody & Wrapsody eCo services.
                                    <br />
                                    To use as basic data for checking
                                    service-related errors and handling
                                    complaints.
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              ② Methods of collecting personal information
                            </h4>
                            <p className="contents">
                              Information is collected through the Company's
                              website and log analysis program.
                            </p>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <h3 className="title">
                          3. Consent to Collection of Personal Information
                        </h3>
                        <p className="contents">
                          The minimum personal information is collected when a
                          user signs up for the Service or while the user uses
                          the Services. In case of collecting personal
                          information, the company informs the items to collect
                          and purposes to a user in advance. If a customer who
                          wants to use the service reads the Terms of Service
                          and this Privacy Policy, enters the required items,
                          and clicks the "Complete" button for sign-up or checks
                          the "OK" or "I Agree" checkbox, it is assumed that the
                          user consents to the processing of personal
                          information.
                        </p>
                      </li>
                      <li>
                        <h3 className="title">
                          4. Retention and Use Period of Personal Information
                        </h3>
                        <p className="contents">
                          When a member withdraws or the purpose of collecting
                          and using personal information is achieved, the
                          personal information of the member is destroyed
                          without delay. However, it is retained for a certain
                          period of time if it is necessary for reasons such as
                          the confirmation of the management obligations
                          regarding transaction in accordance with the
                          provisions of related laws and regulations such as the
                          Commercial Act.
                        </p>
                        <table>
                          <thead>
                            <tr>
                              <th className="th">Grounds Act</th>
                              <th className="th">
                                Information to be retained.
                              </th>
                              <th className="th">Retention Period</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td className="td">
                                Consumer Protection Act in Electronic Commerce
                              </td>
                              <td className="td">
                                Records on contract or withdrawal of
                                subscription
                              </td>
                              <td className="td">5 year</td>
                            </tr>
                            <tr>
                              <td className="td">
                                Consumer Protection Act in Electronic Commerce,
                                Commercial Law, Basic National Tax Law, Income
                                Tax Law, Corporate Tax Law, VAT Law
                              </td>
                              <td className="td">
                                Records on payment and supply of goods, etc,
                                commercial accounting books and statements of
                                business, and documentary evidences
                              </td>
                              <td className="td">5 year</td>
                            </tr>
                            <tr>
                              <td className="td">
                                Consumer Protection Act in Electronic Commerce
                              </td>
                              <td className="td">
                                Records of consumer complaints or disputes
                              </td>
                              <td className="td">3 year</td>
                            </tr>
                            <tr>
                              <td className="td">
                                Communication Secret Protection Act
                              </td>
                              <td className="td">Records of site visits</td>
                              <td className="td">3 month</td>
                            </tr>
                          </tbody>
                        </table>
                      </li>
                      <li>
                        <h3 className="title">
                          5. The Procedure and Methods to Dispose of Personal
                          Information
                        </h3>
                        <ul>
                          <li>
                            <h4 className="subTitle">Processes of disposal</h4>
                            <p className="contents">
                              Personal information entered by customers for
                              service subscription is deleted or destroyed in
                              accordance with the internal policy and
                              information protection policy according to other
                              related laws after the purpose of use is achieved
                              for reasons such as termination of service.
                              Generally, if there is no debt relationship,
                              personal information collected when registering as
                              a member and managed in the form of an electronic
                              file is immediately deleted upon membership
                              withdrawal.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">Methods of disposal</h4>
                            <p className="contents">
                              A. Personal information in written documents:
                              shredding, incineration, or chemical decomposition
                            </p>
                            <p className="contents">
                              B. Personal information in digital file forms:
                              deleted by using technology that prevents the
                              recovery of such records
                            </p>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <h3 className="title">
                          6. The Rights of Members and Legal Representatives and
                          How to Exercise the rights
                        </h3>
                        <p className="contents">
                          Registered members and legal representatives can view
                          or modify personal information of their own or
                          children under the age of 14 at any time and may
                          request termination of membership.
                        </p>
                        <p className="contents">
                          The personal information of a member of a child under
                          the age of 14 can be viewed or modified by clicking
                          Account Information. The subscription can be canceled
                          (consent withdrawal) by clicking the "Withdrawal of
                          Membership" and going through the identity
                          verification process. Or the member can contact the
                          person in charge of personal information management by
                          writing, telephone, or email, the company will take
                          action without delay.
                        </p>
                        <p className="contents">
                          If you request to correct an error in personal
                          information, the personal information will not be used
                          or provided to a third party until the correction is
                          completed. If incorrect personal information has
                          already been provided to a third party, we will notify
                          the third party without delay.
                        </p>
                        <p className="contents">
                          The company handles the personal information that is
                          withdrawn or deleted at the request of a member or
                          legal representative as described in "4. Retention and
                          Use Period of Personal Information" and processes it
                          so that it cannot be viewed or used for other
                          purposes.
                        </p>
                        <p className="contents">
                          Please enter your personal information accurately and
                          up to date. Members are responsible for accidents
                          caused by incorrect information entered by members,
                          and you will lose your qualifications for membership
                          if false information such as theft of other
                          information is entered.
                        </p>
                        <p className="contents">
                          Members have an obligation not to infringe on other's
                          information along with the right to privacy. Be
                          careful not to leak personal information of members,
                          including passwords, and be careful not to damage
                          other people's personal information, including posts.
                          If you damage other people's information, you may be
                          punished by the Act on Promotion of Information and
                          Communication Network Utilization and Information
                          Protection, etc.
                        </p>
                      </li>
                      <li>
                        <h3 className="title">
                          7. Technical/organizational Management for the
                          Protection of Personal Information
                        </h3>
                        <ul>
                          <li>
                            <h4 className="subTitle">Technical measures</h4>
                            <p className="contents">
                              FASOO takes the following technical measures to
                              secure the stability of the personal information
                              of our customers, so that there is no loss, theft,
                              leakage, external attack or damage to the
                              information.
                            </p>
                            <ul>
                              <li>
                                <p className="contents">
                                  ① The personal information of the customer is
                                  secured using passwords, and important data is
                                  protected with a special security function by
                                  encrypting or locking the file and the
                                  transmission data.
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  ② The Company selects the security solution
                                  (SSL or SET) for the safe transmission of
                                  personal information, using an encrypted
                                  algorithm.
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  ③ The Company is fully engaged in security
                                  matters by using a firewall system and a
                                  vulnerability analysis system on each server,
                                  to prevent external attacks such as hacking.
                                </p>
                              </li>
                            </ul>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              Organizational measures
                            </h4>
                            <ul>
                              <li>
                                <p className="contents">
                                  ① For the safe protection of personal
                                  information, we are operating major systems
                                  and facilities with certified information
                                  protection management systems by an objective
                                  certification body.
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  ② The Company implemented required processes
                                  to access personal information and to manage
                                  and ensure the employees are aware of and
                                  follow the processes.
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  ③ The Company shall minimize the number of
                                  persons authorized to access personal
                                  information on customers as follows.
                                </p>
                                <ul>
                                  <li>
                                    <p className="contents">
                                      a. Those who conduct direct marketing
                                      activities toward users
                                    </p>
                                  </li>
                                  <li>
                                    <p className="contents">
                                      b. Those who manage personal information
                                      including Privacy Supervisor and Privacy
                                      Personnel
                                    </p>
                                  </li>
                                  <li>
                                    <p className="contents">
                                      c. Those who are obligated to handle
                                      personal information due to business
                                    </p>
                                  </li>
                                </ul>
                              </li>
                              <li>
                                <p className="contents">
                                  ④ The Company implemented required processes
                                  to access personal information and to manage
                                  and ensure the employees are aware of and
                                  follow the processes, and holds regular
                                  company training and outsourced training for
                                  employees who deal with personal information
                                  to acquire new security technology and methods
                                  of protecting personal information.
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  ⑤ Transferring duties and responsibilities
                                  between people who handles personal
                                  information is performed thoroughly while
                                  security is maintained. We clarify where the
                                  responsibility lies for personal information
                                  accidents after employees leave the company or
                                  join the Company.
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  ⑥ The computer room and data storage room are
                                  set as special protected areas to control
                                  access.
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  ⑦ When processing a customer's personal
                                  information using a computer, a person with
                                  access to the personal information is
                                  designated and assigned an identification code
                                  (ID) and password, and the password is
                                  regularly updated.
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  ⑧ The company prevents information leakage by
                                  employees in advance by requiring new
                                  employees to sign the Privacy Protection
                                  Pledge when hiring, and establishes and
                                  constantly implements internal procedures to
                                  audit the implementation of personal
                                  information processing policies and compliance
                                  with employees.
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  ⑨ The company prevents the person who handled
                                  the customer's personal information from
                                  compromising, infringing, or divulging the
                                  personal information by requiring them to sign
                                  the Privacy Protection Pledge when they
                                  retire.
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  ⑩ The Company check the customer's identity
                                  when collecting or providing payment
                                  information such as credit card numbers and
                                  bank settlement accounts for the purpose of
                                  signing service contracts and providing
                                  services.
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  ⑪ The company is not responsible for accidents
                                  or events caused by a user's personal mistake
                                  or basic internet risk. Each member should
                                  appropriately manage own ID and password and
                                  be responsible for it for personal information
                                  protection. Also, it is recommended to avoid
                                  using an easy password that others might be
                                  able to guess and to change the password
                                  regularly.
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  ⑫ When you want to stop using our service
                                  while you are logged in to our website on a
                                  shared PC, make sure that you have logged out
                                  and close the webpage before moving to another
                                  website. Otherwise, information such as e-mail
                                  and password can be easily leaked to others
                                  through the browser.
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  ⑬ In other cases of personal information loss,
                                  disclosure, falsification and damage due to a
                                  mistake by an internal managing staff or a
                                  technological management accident, the Company
                                  will inform you instantly and look for
                                  appropriate response and compensation method.
                                </p>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <h3 className="title">
                          8. Personal Information Management Officer
                        </h3>
                        <p className="contents">
                          We value the Personal Information of our customers and
                          try our best not to prevent member's personal
                          information from being damaged, infringed, or leaked.
                          In the event of an infringement of a member's personal
                          information due to the Company's fault, we notify the
                          member in accordance with the procedures and methods
                          prescribed by the relevant laws and regulations such
                          as the Personal Information Protection Act and the
                          Information and Communication Network Act and report
                          to related organization. However, the Company is not
                          responsible for information damage by unexpected
                          accident caused by basic network threats such as
                          hacking occurring despite technological security
                          measures in place and disputes over posts written by
                          visitor.
                        </p>
                        <p className="contents">
                          The Company appointed a Personal Information Manager
                          and a relevant department as below, to protect the
                          personal information of our customers and to take care
                          of any complaints and inquiries related to this
                          information.
                        </p>
                        <table>
                          <thead>
                            <tr>
                              <th scope="col"></th>
                              <th scope="col">Personal Information Manager</th>
                              <th scope="col">
                                Personal Information Management Staff
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <th scope="row">Name</th>
                              <td className="td">Young-gil Kim</td>
                              <td className="td">Hyunsu Park</td>
                            </tr>
                            <tr>
                              <th scope="row">Title</th>
                              <td className="td">Managing Director</td>
                              <td className="td">
                                Principal Research Engineer
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">E-mail</th>
                              {/* <td colSpan={2}>kimyg@fasoo.com</td> */}
                              <td className="td">kimyg@fasoo.com</td>
                              <td className="td">hspark@fasoo.com</td>
                            </tr>
                            <tr>
                              <th scope="row">Phone</th>
                              <td colSpan={2}>82)2-300-9120</td>
                            </tr>
                          </tbody>
                        </table>
                      </li>
                      <li>
                        <h3 className="title">
                          9. Obligation for Notification
                        </h3>
                        <p className="contents">
                          The current privacy policy was revised on January 31,
                          2018. Should there be information to be added,
                          deleted, and edited according to government policies
                          or a change in the security technology, notification
                          of this will be provided via the website at least
                          seven days before the revision.
                        </p>
                        <p className="contents">
                          The privacy policy takes effect on June 1, 2023
                        </p>
                      </li>
                    </ul>
                    {/* <button
                      type="button"
                      onClick={() => {
                        showEcoHistoryContent();
                        moveScrollTop();
                      }}
                      className="btn btn-green height h-40 mg mt-10 mr-20"
                    >
                      <span className="policyHistory">
                        See past Wrapsody eCo Service privacy policy &gt;
                      </span>
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        showWrapsodyHistoryContent();
                        moveScrollTop();
                      }}
                      className="btn btn-green height h-40 mg mt-10"
                    >
                      <span className="policyHistory">
                        See past Wrapsody Service privacy policy &gt;
                      </span>
                    </button> */}
                  </div>
                )}
            </div>
            {/* 유료 이용약관 */}
            {/* <div
              className={`tab_content ${tabTarget === "tab3" ? "active" : ""}`}
              style={{
                display:
                  window.location.pathname.substring(3) === "/join"
                    ? "none"
                    : "inline",
              }}
            >
              {window.sessionStorage.getItem("product") === "WRAPSODY_ECO" &&
                language === "ko" && (
                  <div className="modalWindow">
                    <ul>
                      <li>
                        <h3 className="title">1장 총칙</h3>
                        <ul>
                          <li>
                            <h4 className="subTitle">제1조 (목적)</h4>
                            <p className="contents">
                              본 약관은 회원이 주식회사 파수(이하 "회사")에서
                              제공하는 유무선 인터넷 서비스인 Wrapsody eCo
                              서비스(이하 “서비스”)를 이용하면서 유료상품을
                              구매할 때 발생하는 회원과 회사 간의 권리, 의무 및
                              책임사항을 규정함을 목적으로 합니다.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              제2조 (약관의 효력 및 변경)
                            </h4>
                            <p className="contents">
                              본 약관의 내용은 서비스의 인터넷
                              홈페이지(http://www.wrapsodyeco.com 이하
                              "홈페이지") 또는 서비스 화면에 게시하거나 기타의
                              방법으로 회원에게 공시하고, 이에 동의한 회원이
                              유료상품에 가입하고 비용을 결제함으로써 효력이
                              발생합니다.
                            </p>
                            <p className="contents">
                              회사는 필요하다고 인정되면 본 약관을 변경할 수
                              있으며, 회사가 약관을 변경할 때에는 적용일자와
                              변경사유를 구체적으로 기재하여 본 조와 같은
                              방법으로 변경 약관 적용일 14일 전에 공시합니다.
                              다만, 변경할 약관이 회원에게 불리할 때에는 해당
                              내용을 적용일자 30일 전부터 공지하며,
                              이메일(e-mail) 등으로 회원에게 개별적으로
                              통지합니다. (회원의 연락처 미기재, 변경 등으로
                              회원에게 해당 내용을 개별통지 하기가 어려우면
                              "홈페이지"에 변경 약관을 공지하는 것으로 개별
                              통지를 대신합니다.)
                            </p>
                            <p className="contents">
                              회사가 약관의 변경 시 본 조에 따른 조치를
                              하였음에도 불구하고 회원이 개정 약관을 인지하지
                              못하여 발생하는 손해에 대해 회사는 책임을 지지
                              않습니다.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">제3조 (약관 외 준칙)</h4>
                            <p className="contents">
                              본 약관에 기재되지 않은 사항은 정보통신망 이용촉진
                              및 정보보호에 관한 법률(이하 "정보통신망법"),
                              전기통신기본법, 전기통신사업법 등 관계 법령 및
                              회사가 정한 본 서비스의 세부이용지침 등의 규정을
                              따릅니다.
                            </p>
                            <p className="contents">
                              회사는 필요하면 본 서비스 이용과 관련된
                              세부이용지침을 정하여 이를 제2조의 방법으로 공지할
                              수 있습니다.
                            </p>
                            <p className="contents">
                              본 약관과 관련하여 회사의 정책변경, 법령의
                              제ㆍ개정 또는 공공기관의 고시나 지침 등에 따라
                              회사가 "홈페이지"의 공지사항 게시판 등에 공지하는
                              내용도 이용계약의 일부를 구성합니다.
                            </p>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <h3 className="title">2장 유료상품 이용계약</h3>
                        <ul>
                          <li>
                            <h4 className="subTitle">
                              제4조 (이용계약의 성립)
                            </h4>
                            <p className="contents">
                              이용계약은 회원이 되고자 하는 자의 본 약관 내용에
                              대한 동의와 "유료 상품 구매 신청"에 대하여 회사가
                              이를 승낙함으로써 성립됩니다.
                            </p>
                            <p className="contents">
                              회사와 회원간 유료서비스 이용계약은 회사의 승낙이
                              회원에게 도달한 시점(유료서비스의 “구매/결제완료
                              등”의 표시가 회원에게 절차상 표시된 시점)에
                              성립합니다.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">제5조 (구매신청)</h4>
                            <p className="contents">
                              회원이 되고자 하는 자는 회사가 정하는 구매 신청
                              양식에 따라 필요한 정보를 기입합니다.
                            </p>
                            <p className="contents">
                              구매 신청자는 타인의 정보를 도용하는 경우 서비스
                              이용이 제한되거나, 관계 법령에 따라 처벌 받을 수
                              있습니다.
                            </p>
                            <p className="contents">
                              구매 신청 시 허위 정보를 제공해서는 아니 되며,
                              허위 정보로 인해 발생하는 문제에 대하여 회사는
                              책임지지 않습니다.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              제6조 (구매신청의 승낙과 제한)
                            </h4>
                            <p className="contents">
                              회사는 제 6조의 규정에 의한 구매 신청회원에 대하여
                              업무 수행상 또는 기술상 지장이 없는 경우에
                              원칙적으로 접수 순서에 따라 서비스 이용을
                              승낙합니다.
                            </p>
                            <p className="contents">
                              회사는 다음 각 호의 어느 하나에 해당하는 경우에
                              대해서 승낙하지 않거나 승낙을 유보할 수 있습니다.
                            </p>
                            <ul>
                              <li>
                                <p className="contents">
                                  ① Wrapsody eCo 운영 원칙에서 정한 비정상
                                  이용에 해당하는 경우
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  ② 음란물의 배포 전시 및 타인의 저작권을
                                  침해하거나 침해할 가능성이 있는 경우
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  ③ 악성 프로그램 및 버그를 이용하거나 시스템
                                  취약점을 악용하는 등 부정한 방법을 서비스에
                                  사용한 경우
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  ④ 영리를 추구할 목적으로 본 서비스를
                                  이용하고자 하는 경우
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  ⑤ 기타 회사에서 규정한 제반 사항을 위반하여
                                  신청하는 경우
                                </p>
                              </li>
                            </ul>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              제7조 (유료상품의 종류)
                            </h4>
                            <p className="contents">
                              유료상품의 종류 및 이용요금 등과 관련된 내용은 각
                              상품 표시 페이지를 통해 안내합니다.
                            </p>
                            <p className="contents">
                              회사는 일정 기간 공지를 통하여 유료상품을 수시로
                              변경하거나 해당 상품의 판매를 중단할 수 있으며,
                              신규 상품이나 이벤트 상품을 추가할 수 있습니다
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              제8조 (유료상품의 중단 및 변경)
                            </h4>
                            <p className="contents">
                              사업 종목의 전환, 사업의 포기, 업체 간 통합, 품절
                              등의 이유로 유료상품을 제공할 수 없게 되면 회사는
                              서비스 이용약관에서 정한 방법으로 이용자에게
                              통지하고 애초 회사에서 제시한 조건으로 회원에게
                              보상합니다.
                            </p>
                            <p className="contents">
                              유료상품에 대한 변경 사항은 회사가 해당 유료상품을
                              제공받거나 신청한 이용자에게 통지합니다. 이때,
                              회사는 상품 제공을 중지하거나 계약을 해지할 수
                              있으며, 환불 등은 각 유료상품 요금 환불 절차에
                              따라 진행하며, 잔여일수에 비례한 유료상품 대금
                              청구를 중지하거나 해지일로부터 3영업일 이내에 해당
                              대금을 환급합니다. 회사가 회원에게 대금의 환급을
                              지연한 때에는 그 지연기간에 “전자상거래 등에서의
                              소비자보호에 관한 법률 시행령”이 정하는
                              지연이자율을 곱하여 산정한 지연이자를 지급합니다.
                            </p>
                            <p className="contents">
                              유료 상품을 추가 구매할 경우 기존 구매 상품의
                              구독이 끝나는 시점까지 일할 계산되어 청구되며,
                              구독 갱신 시점에 통합 청구됩니다.{" "}
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              제9조 (청약 철회 및 요금의 반환)
                            </h4>
                            <p className="contents">
                              회원은 유료상품 구매 결제일로부터 7일 이내에 유료
                              상품을 이용한 이력이 없으면 청약 철회를 할 수
                              있으며, 회사의 귀책사유로 회원이 유료 상품을
                              해지할 때에는 제10조를 따릅니다.
                            </p>
                            <p className="contents">
                              회사는 요금 등이 잘못 납부되었을 때에는 해당
                              요금을 반환합니다. 단, 이용자가 동의하거나 회사의
                              반환 통지에 응하지 않으면 다음달 요금에서 해당
                              요금을 차감하여 청구할 수 있습니다.
                            </p>
                            <p className="contents">
                              회사는 요금 등을 반환해야 할 이용자에게 미납 요금
                              등이 있으면 미납 요금과 상계하고 그 잔액을 반환할
                              수 있습니다.
                            </p>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <h3 className="title">3장 손해배상 및 면책</h3>
                        <ul>
                          <li>
                            <h4 className="subTitle">제10조 (손해배상)</h4>
                            <p className="contents">
                              회사의 귀책 사유로 회원이 "유료 상품"을 이용하지
                              못하는 경우, 회사는 이에 대한 손해를 배상합니다.
                              다만, 회원이 이용 불가 사실을 회사에 접수한 이후
                              2시간 이내 정상화된 경우는 제외합니다.
                            </p>
                            <p className="contents">
                              회사의 귀책사유로 회원이 유료상품을 이용하지
                              못하게 되면 회원이 그 사실을 회사에 통보하여
                              확인한 때(그 전에 회사가 그 사실을 알게 된 때에는
                              그때)로부터 2시간 이상 또는 월별누적시간 12시간을
                              초과하여 중지 또는 장애로 인한 피해에 대하여 최근
                              3개월(3개월 미만이면 해당 기간 적용)의 1일 평균
                              요금에 제공 중지 또는 장애 시간을 24로 나눈 수를
                              곱하여 산출한 금액의 한도 내에서 회원과 협의하여
                              배상합니다. 이때 단수가 1시간 미만이면 1시간으로
                              합니다.
                            </p>
                            <p className="contents">
                              본 약관의 규정을 위반하여 회사에 손해를 끼친
                              회원은 회사에 발생하는 모든 손해를 배상해야
                              합니다.
                            </p>
                            <p className="contents">
                              회원이 유료상품을 이용하면서 불법행위를 하였거나
                              본 약관을 위반하여 회사가 해당 회원 이외의
                              제3자로부터 손해배상 청구 또는 소송을 비롯한 각종
                              이의를 제기 받는다면 해당 회원은 자신의 책임과
                              비용으로 회사를 면책시켜야 하며, 이와 관련하여
                              회사에 발생한 모든 손해를 배상해야 합니다.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">제11조 (면책사항)</h4>
                            <p className="contents">
                              회사는 천재지변이나 그와 비슷한 불가항력으로
                              유료상품을 제공할 수 없게 된다면 그 제공에 대한
                              책임이 면제됩니다.
                            </p>
                            <p className="contents">
                              회사는 전기통신서비스 특성상 불가피한 사유로
                              서비스를 제공할 수 없거나 관련 설비의 보수, 교체,
                              정기점검, 공사 등 부득이한 사유로 일시적으로
                              서비스를 중단하게 된다면 그것에 대해 책임을 지지
                              않습니다.
                            </p>
                            <p className="contents">
                              고의, 과실 또는 서비스 이용방법의 미숙지 등 회원의
                              귀책사유로 말미암아 회원의 서비스 이용에 장애가
                              발생하고, 회원 정보나 자료가 소실되는 등 회원에게
                              손해가 발생했을 때 회사는 책임을 지지 않습니다.
                            </p>
                            <p className="contents">
                              회원이 신상정보와 이메일(e-mail) 주소를 부실하게
                              기재하여 손해가 발생했을 때 회사는 책임을 지지
                              않습니다.
                            </p>
                            <p className="contents">
                              회사는 회원이 유료상품을 이용하여 기대하는 수익을
                              상실한 것에 대하여 책임을 지지 않으며, 그 밖의
                              유료상품을 통하여 얻은 자료로 손해가 발생했을
                              때에도 책임을 지지 않습니다.
                            </p>
                            <p className="contents">
                              회사는 회원이 유료상품을 이용하여 자료를
                              게시ㆍ전송ㆍ저장ㆍ조회했을 때 발생하는 법적인
                              문제에 대해 책임을 지지 않습니다.
                            </p>
                            <p className="contents">
                              회사는 회원 상호 간 또는 회원과 제3자 상호 간에
                              서비스를 매개로 발생한 분쟁에 개입할 의무가 없으며
                              이 때문에 발생한 손해를 배상할 책임도 없습니다.
                            </p>
                            <p className="contents">
                              회원이 자신의 개인정보를 타인에게 유출 또는
                              제공하거나, 아이디(ID)와 비밀번호(PASSWORD)의 분실
                              및 무단 사용, 관리소홀 등으로 피해가 발생했을 때
                              회사는 일절 책임을 지지 않습니다.
                            </p>
                            <p className="contents">
                              회사는 회원의 컴퓨터 오류, 제3자 제공 프로그램의
                              종료 및 오류, 네트워크 환경상의 장애 및 오류로
                              파일이 손상되었거나 업로드 도중에 파일이 잘못
                              저장된 것에 대해 책임을 지지 않습니다.
                            </p>
                            <p className="contents">
                              회원상태 변경, 계약만료 또는 요금 미납의 결과로
                              회원계정이 정지되거나 보관파일이 삭제되어 회원에게
                              손해가 발생했을 때 회사는 책임을 지지 않습니다.
                            </p>
                            <p className="contents">
                              서비스 화면에서 링크, 배너 등으로 연결된 회사(이하
                              피연결회사)와 회원 간에 이루어진 거래에 회사는
                              개입하지 않으며, 해당 거래에 대해 책임을 지지
                              않습니다.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">제12조 (재판권 관할)</h4>
                            <p className="contents">
                              회사와 회원간 발생한 분쟁에 관한 소송은 민사소송법
                              등 관련 법령에 따른 관할법원에 제소합니다.
                            </p>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <h3 className="title">부칙</h3>
                        <p className="contents">
                          본 약관은 2020년 07월 01일 부터 적용됩니다.
                        </p>
                      </li>
                    </ul>
                  </div>
                )}

              {window.sessionStorage.getItem("product") === "WRAPSODY_ECO" &&
                language === "en" && (
                  <div className="inner modalWindow">
                    <ul>
                      <li>
                        <h3 className="title">Chapter 1 General Provisions</h3>
                        <ul>
                          <li>
                            <h4 className="subTitle">Article 1 (Purpose)</h4>
                            <p className="contents">
                              These provisions aim to prescribe Fasoo Co., Ltd
                              (hereafter "the Company") and its users' rights,
                              obligations, and responsibilities in using wired
                              and wireless internet service, Wrapsody eCo
                              service (hereafter "the Service").
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              Article 2 (Effect and Changes of Terms of
                              Services)
                            </h4>
                            <p className="contents">
                              The contents of these Terms of Services are posted
                              on the service's Internet homepage
                              (http://www.wrapsodyeco.com, hereinafter "Home
                              page") service screen or otherwise disclosed to
                              the member, and payment takes effect when the
                              member who agrees to this, subscribes to the paid
                              product, and pays for it.
                            </p>
                            <p className="contents">
                              The company can change these Terms of Services if
                              it is deemed necessary. When the company changes
                              the terms and conditions, the date of application
                              and the reason for the change are specifically
                              stated and announced 14 days before the date of
                              application in the same manner of this article.
                              However, If the modification is unfavorable to
                              users, the Company shall post 30 days' prior
                              notice of such change and notify members
                              individually via email or etc. (If it is difficult
                              to notify the member individually due to the
                              member's contact information not being written or
                              changed, the notice of the change is posted on the
                              "homepage" to replace the individual notice.)
                            </p>
                            <p className="contents">
                              If the company has taken measures as described in
                              this article when changing this Terms of Service,
                              the Company is not responsible for the member's
                              damage caused by ignorance of the changed Terms of
                              Service
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              Article 3 (Other terms and conditions)
                            </h4>
                            <p className="contents">
                              Any matters that are not prescribed in this Terms
                              of Service shall be subject to the relevant laws
                              and regulations such as the Act on Promotion of
                              Information and Communication Network Utilization
                              and Information Protection (hereinafter
                              "Information and Communication Network Act"), the
                              Basic Telecommunications Act, and the
                              Telecommunications Business Act, as well as the
                              detailed guidelines to use the Service set by the
                              Company.
                            </p>
                            <p className="contents">
                              The Company, if deemed necessary, can set detailed
                              guidelines to use the Service and announce them in
                              a way described in Article 2.
                            </p>
                            <p className="contents">
                              The contents that the company announces on the
                              bulletin board of the homepage regarding company's
                              policy changes, enactment and amendment of
                              legislation, and public notices or guidelines of
                              public institutions in relation to these terms and
                              conditions, also form part of the use agreement.
                            </p>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <h3 className="title">
                          Article 2 Service Use Contract of Paid Plans
                        </h3>
                        <ul>
                          <li>
                            <h4 className="subTitle">
                              Article 4 (Establishment of contract of use)
                            </h4>
                            <p className="contents">
                              The use agreement is established by the Company
                              when the person who wants to become a member
                              agrees to the Terms of Services and the company
                              accepts the "application of paid product
                              purchase".
                            </p>
                            <p className="contents">
                              The contract for the use of the paid service
                              between the company and the member is established
                              at the time when the company's consent reaches the
                              member (when the indication of "purchase/payment,
                              etc." of the paid service is displayed
                              procedurally to the member).
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              Article 5 (Purchase Request)
                            </h4>
                            <p className="contents">
                              The person who wants to be a member fills out the
                              necessary information according to the purchase
                              application form determined by the company.
                            </p>
                            <p className="contents">
                              Applicants for purchases may be restricted from
                              using the service if they steal information from
                              others, or they may be punished according to
                              related laws.
                            </p>
                            <p className="contents">
                              When purchasing, you must not provide false
                              information, and the company is not responsible
                              for any problems caused by false information.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              Article 6 (Acceptance and Limitation of Purchase
                              Request)
                            </h4>
                            <p className="contents">
                              The Company accepts the use of the service in the
                              order in which it is received if there is no
                              business or technical obstacle to the member who
                              requested purchase according to the regulations in
                              Article 6.
                            </p>
                            <p className="contents">
                              The company may not approve or withhold consent
                              for any of the following cases:
                            </p>
                            <ul>
                              <li>
                                <p className="contents">
                                  ① In the case of abnormal use determined by
                                  the Wrapsody eCo operating principle
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  ② In case of infringement or possible
                                  infringement of copyrights of others and
                                  distribution exhibitions of pornography
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  ③ When illegal methods are used for services,
                                  such as using malicious programs and bugs or
                                  exploiting system vulnerabilities.
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  ④ When trying to use the service to make
                                  profit
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  ⑤ When violating other regulations prescribed
                                  by the Companies
                                </p>
                              </li>
                            </ul>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              Article 7 (Types of Paid Products)
                            </h4>
                            <p className="contents">
                              Information related to the types of paid products,
                              usage fees, etc. is guided through each product
                              page.
                            </p>
                            <p className="contents">
                              The Company may change paid products from time to
                              time, or discontinue the sale of those products,
                              and add new or event products through a certain
                              period of notice.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              Article 8 (Suspension and Change of Paid Products)
                            </h4>
                            <p className="contents">
                              If it is not possible to provide paid products for
                              reasons such as conversion of business items,
                              abandonment of business, integration between
                              companies, and out of stock, the company notifies
                              the user in the manner specified in the Terms of
                              Service of the Service and compensates the member
                              under the conditions originally proposed by the
                              Company.
                            </p>
                            <p className="contents">
                              Changes to paid products are notified to users who
                              have received or applied for the paid products. In
                              this case, the Company may stop providing the
                              product or cancel the contract, and refunds, etc.
                              will be performed according to the refund
                              procedure for each paid product fee, and stop
                              charging the paid product in proportion to the
                              remaining number of days or refund the relevant
                              price within 3 business days from the termination
                              date. When the company delays the refund of the
                              price to the member, the delayed interest
                              calculated by multiplying the delayed interest
                              rate prescribed by the Enforcement Decree of the
                              Act on Consumer Protection in Electronic Commerce,
                              etc. should be paid for the delayed period.
                            </p>
                            <p className="contents">
                              If you purchase additional paid products, it will
                              be calculated and charged daily until the end of
                              subscription of the existing purchased products,
                              and will be charged at the time of subscription
                              renewal.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              Article 9 (Withdrawal of Subscription and Return
                              of Fees)
                            </h4>
                            <p className="contents">
                              Members can withdraw their subscription of paid
                              products if they have not use the products within
                              7 days from the purchasing date. If the member
                              cancels the paid product for reasons attributable
                              to the company, it is subject to Article 10.
                            </p>
                            <p className="contents">
                              The company will return the fee if the fee is
                              incorrectly paid. However, if the user agrees or
                              does not respond to the company's return notice,
                              the charge may be deducted from the next month's
                              rate. The company will return the fee in case of
                              erroneous payment. However, if the user agrees or
                              does not respond to the company's return notice,
                              the charge may be deducted from the next month's
                              rate.
                            </p>
                            <p className="contents">
                              The company can offset the unpaid charges and
                              return the balance if there are unpaid charges for
                              users who need to return the charges.
                            </p>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <h3 className="title">
                          Chapter 3 Compensation and Disclaimer
                        </h3>
                        <ul>
                          <li>
                            <h4 className="subTitle">
                              Article 10 (Compensation for Damages)
                            </h4>
                            <p className="contents">
                              If the member cannot use the "Paid Service" due to
                              the Company's fault, the company compensates for
                              this except when it is normalized within 2 hours
                              after the member reports the fact that the Service
                              is not available.
                            </p>
                            <p className="contents">
                              If the member is unable to use the paid product
                              due to the company's fault, the company
                              compensates the damage after consulting the member
                              for the damage that has been lasted for more than
                              2 hours from when the member notifies the company
                              (when the company recognizes if they recognize
                              earlier than the user) or when accumulated damages
                              caused by suspension or failure of each month
                              exceeds 12 hours within the limit of the amount
                              calculated by multiplying the average daily rate
                              for the last 3 months (the applicable period if it
                              is less than 3 months) by the number of suspension
                              or failure hours divided by 24.
                            </p>
                            <p className="contents">
                              Members who damage the company in violation of the
                              provisions of these terms and conditions must
                              compensate all damages incurred by the company.
                            </p>
                            <p className="contents">
                              If a member has illegally acted while using a paid
                              product or violated these Terms of Services and
                              the Company receives various complaints including
                              claims for damages or lawsuits from third parties
                              other than the member, the member should indemnify
                              and reimburse any damages to the company.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              Article 11 (Disclaimer)
                            </h4>
                            <p className="contents">
                              If the Company is unable to provide the Paid
                              Service due to a natural disaster or equivalent
                              force majeure, the Company is exempted from
                              liability for Service provision.
                            </p>
                            <p className="contents">
                              The Company is not responsible for the inability
                              to provide the service due to the inevitable
                              reasons of the telecommunication service or
                              temporarily stop the service due to unavoidable
                              reasons such as repair, replacement, regular
                              inspection, and construction of related
                              facilities.
                            </p>
                            <p className="contents">
                              The Company is not responsible for any damage
                              caused to the member, such as intentional,
                              negligent or inadequate use of the service, due to
                              the member's fault, the member's use of the
                              service, and loss of member information or data.
                            </p>
                            <p className="contents">
                              The Company is not responsible for any loss caused
                              by the member's incorrect information and e-mail
                              address.
                            </p>
                            <p className="contents">
                              The Company is not responsible for losing the
                              expected profits of members using paid products,
                              and is not responsible for damages caused by data
                              obtained through other paid products.
                            </p>
                            <p className="contents">
                              The Company is not responsible for any legal
                              issues arising when a member posts, transmits,
                              stores, or queries data using paid products.
                            </p>
                            <p className="contents">
                              The Company is not obliged to intervene in
                              disputes between members or between a member and a
                              third party that arose from the service as a
                              medium, and is not responsible for reimbursing
                              damages.
                            </p>
                            <p className="contents">
                              The Company is not responsible for any loss or
                              damage caused by the loss or unauthorized use of
                              the ID and password, or the negligence of
                              management, if the member leaks or provides his or
                              her personal information to others.
                            </p>
                            <p className="contents">
                              The Company is not responsible for any damage to
                              the file due to a member's computer error,
                              termination and error of a third-party-provided
                              program, failures or errors in the network
                              environment, or incorrect storage of the file
                              during upload.
                            </p>
                            <p className="contents">
                              The Company is not responsible for any damage to
                              the member when account is suspended or the
                              archive file is deleted as a result of membership
                              status change, contract expiration, or failure to
                              pay the fee.
                            </p>
                            <p className="contents">
                              The Company does not intervene in the transactions
                              made between the company (hereinafter referred to
                              as the linked company) linked to the service
                              screen suing links or banners and its members, and
                              is not responsible for the transactions.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              Article 12 (Jurisdictions)
                            </h4>
                            <p className="contents">
                              Lawsuits related to disputes between the company
                              and members are filed with the competent court
                              according to related laws such as the Civil
                              Procedure Act.
                            </p>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <h3 className="title">Supplementary provisions</h3>
                        <p className="contents">
                          These Terms of Service takes effect on July 1, 2020.
                        </p>
                      </li>
                    </ul>
                  </div>
                )}

              {window.sessionStorage.getItem("product") === "WRAPSODY" &&
                language === "ko" && (
                  <div className="modalWindow">
                    <ul>
                      <li>
                        <h3 className="title">1장 총칙</h3>
                        <ul>
                          <li>
                            <h4 className="subTitle">제1조 (목적)</h4>
                            <p className="contents">
                              본 약관은 회원이 주식회사 파수(이하 "회사")에서
                              제공하는 유무선 인터넷 서비스인 Wrapsody
                              서비스(이하 “서비스”)를 이용하면서 유료상품을
                              구매할 때 발생하는 회원과 회사 간의 권리, 의무 및
                              책임사항을 규정함을 목적으로 합니다.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              제2조 (약관의 효력 및 변경)
                            </h4>
                            <p className="contents">
                              본 약관의 내용은 서비스의 인터넷
                              홈페이지(http://www.wrapsody.com 이하 "홈페이지")
                              또는 서비스 화면에 게시하거나 기타의 방법으로
                              회원에게 공시하고, 이에 동의한 회원이 유료상품에
                              가입하고 비용을 결제함으로써 효력이 발생합니다.
                            </p>
                            <p className="contents">
                              회사는 필요하다고 인정되면 본 약관을 변경할 수
                              있으며, 회사가 약관을 변경할 때에는 적용일자와
                              변경사유를 구체적으로 기재하여 본 조와 같은
                              방법으로 변경 약관 적용일 14일 전에 공시합니다.
                              다만, 변경할 약관이 회원에게 불리할 때에는 해당
                              내용을 적용일자 30일 전부터 공지하며,
                              이메일(e-mail) 등으로 회원에게 개별적으로
                              통지합니다. (회원의 연락처 미기재, 변경 등으로
                              회원에게 해당 내용을 개별통지 하기가 어려우면
                              "홈페이지"에 변경 약관을 공지하는 것으로 개별
                              통지를 대신합니다.)
                            </p>
                            <p className="contents">
                              회사가 약관의 변경 시 본 조에 따른 조치를
                              하였음에도 불구하고 회원이 개정 약관을 인지하지
                              못하여 발생하는 손해에 대해 회사는 책임을 지지
                              않습니다.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">제3조 (약관 외 준칙)</h4>
                            <p className="contents">
                              본 약관에 기재되지 않은 사항은 정보통신망 이용촉진
                              및 정보보호에 관한 법률(이하 "정보통신망법"),
                              전기통신기본법, 전기통신사업법 등 관계 법령 및
                              회사가 정한 본 서비스의 세부이용지침 등의 규정을
                              따릅니다.
                            </p>
                            <p className="contents">
                              회사는 필요하면 본 서비스 이용과 관련된
                              세부이용지침을 정하여 이를 제2조의 방법으로 공지할
                              수 있습니다.
                            </p>
                            <p className="contents">
                              본 약관과 관련하여 회사의 정책변경, 법령의
                              제ㆍ개정 또는 공공기관의 고시나 지침 등에 따라
                              회사가 "홈페이지"의 공지사항 게시판 등에 공지하는
                              내용도 이용계약의 일부를 구성합니다.
                            </p>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <h3 className="title">2장 유료상품 이용계약</h3>
                        <ul>
                          <li>
                            <h4 className="subTitle">
                              제4조 (이용계약의 성립)
                            </h4>
                            <p className="contents">
                              이용계약은 회원이 되고자 하는 자의 본 약관 내용에
                              대한 동의와 "유료 상품 구매 신청"에 대하여 회사가
                              이를 승낙함으로써 성립됩니다.
                            </p>
                            <p className="contents">
                              회사와 회원간 유료서비스 이용계약은 회사의 승낙이
                              회원에게 도달한 시점(유료서비스의 “구매/결제완료
                              등”의 표시가 회원에게 절차상 표시된 시점)에
                              성립합니다.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">제5조 (구매신청)</h4>
                            <p className="contents">
                              회원이 되고자 하는 자는 회사가 정하는 구매 신청
                              양식에 따라 필요한 정보를 기입합니다.
                            </p>
                            <p className="contents">
                              구매 신청자는 타인의 정보를 도용하는 경우 서비스
                              이용이 제한되거나, 관계 법령에 따라 처벌 받을 수
                              있습니다.
                            </p>
                            <p className="contents">
                              구매 신청 시 허위 정보를 제공해서는 아니 되며,
                              허위 정보로 인해 발생하는 문제에 대하여 회사는
                              책임지지 않습니다.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              제6조 (구매신청의 승낙과 제한)
                            </h4>
                            <p className="contents">
                              회사는 제 6조의 규정에 의한 구매 신청회원에 대하여
                              업무 수행상 또는 기술상 지장이 없는 경우에
                              원칙적으로 접수 순서에 따라 서비스 이용을
                              승낙합니다.
                            </p>
                            <p className="contents">
                              회사는 다음 각 호의 어느 하나에 해당하는 경우에
                              대해서 승낙하지 않거나 승낙을 유보할 수 있습니다.
                            </p>
                            <ul>
                              <li>
                                <p className="contents">
                                  ① Wrapsody 운영 원칙에서 정한 비정상 이용에
                                  해당하는 경우
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  ② 음란물의 배포 전시 및 타인의 저작권을
                                  침해하거나 침해할 가능성이 있는 경우
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  ③ 악성 프로그램 및 버그를 이용하거나 시스템
                                  취약점을 악용하는 등 부정한 방법을 서비스에
                                  사용한 경우
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  ④ 영리를 추구할 목적으로 본 서비스를
                                  이용하고자 하는 경우
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  ⑤ 기타 회사에서 규정한 제반 사항을 위반하여
                                  신청하는 경우
                                </p>
                              </li>
                            </ul>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              제7조 (유료상품의 종류)
                            </h4>
                            <p className="contents">
                              유료상품의 종류 및 이용요금 등과 관련된 내용은 각
                              상품 표시 페이지를 통해 안내합니다.
                            </p>
                            <p className="contents">
                              회사는 일정 기간 공지를 통하여 유료상품을 수시로
                              변경하거나 해당 상품의 판매를 중단할 수 있으며,
                              신규 상품이나 이벤트 상품을 추가할 수 있습니다
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              제8조 (유료상품의 중단 및 변경)
                            </h4>
                            <p className="contents">
                              사업 종목의 전환, 사업의 포기, 업체 간 통합, 품절
                              등의 이유로 유료상품을 제공할 수 없게 되면 회사는
                              서비스 이용약관에서 정한 방법으로 이용자에게
                              통지하고 애초 회사에서 제시한 조건으로 회원에게
                              보상합니다.
                            </p>
                            <p className="contents">
                              유료상품에 대한 변경 사항은 회사가 해당 유료상품을
                              제공받거나 신청한 이용자에게 통지합니다. 이때,
                              회사는 상품 제공을 중지하거나 계약을 해지할 수
                              있으며, 환불 등은 각 유료상품 요금 환불 절차에
                              따라 진행하며, 잔여일수에 비례한 유료상품 대금
                              청구를 중지하거나 해지일로부터 3영업일 이내에 해당
                              대금을 환급합니다. 회사가 회원에게 대금의 환급을
                              지연한 때에는 그 지연기간에 “전자상거래 등에서의
                              소비자보호에 관한 법률 시행령”이 정하는
                              지연이자율을 곱하여 산정한 지연이자를 지급합니다.
                            </p>
                            <p className="contents">
                              유료 상품을 추가 구매할 경우 기존 구매 상품의
                              구독이 끝나는 시점까지 일할 계산되어 청구되며,
                              구독 갱신 시점에 통합 청구됩니다.{" "}
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              제9조 (청약 철회 및 요금의 반환)
                            </h4>
                            <p className="contents">
                              회원은 유료상품 구매 결제일로부터 7일 이내에 유료
                              상품을 이용한 이력이 없으면 청약 철회를 할 수
                              있으며, 회사의 귀책사유로 회원이 유료 상품을
                              해지할 때에는 제10조를 따릅니다.
                            </p>
                            <p className="contents">
                              회사는 요금 등이 잘못 납부되었을 때에는 해당
                              요금을 반환합니다. 단, 이용자가 동의하거나 회사의
                              반환 통지에 응하지 않으면 다음달 요금에서 해당
                              요금을 차감하여 청구할 수 있습니다.
                            </p>
                            <p className="contents">
                              회사는 요금 등을 반환해야 할 이용자에게 미납 요금
                              등이 있으면 미납 요금과 상계하고 그 잔액을 반환할
                              수 있습니다.
                            </p>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <h3 className="title">3장 손해배상 및 면책</h3>
                        <ul>
                          <li>
                            <h4 className="subTitle">제10조 (손해배상)</h4>
                            <p className="contents">
                              회사의 귀책 사유로 회원이 "유료 상품"을 이용하지
                              못하는 경우, 회사는 이에 대한 손해를 배상합니다.
                              다만, 회원이 이용 불가 사실을 회사에 접수한 이후
                              2시간 이내 정상화된 경우는 제외합니다.
                            </p>
                            <p className="contents">
                              회사의 귀책사유로 회원이 유료상품을 이용하지
                              못하게 되면 회원이 그 사실을 회사에 통보하여
                              확인한 때(그 전에 회사가 그 사실을 알게 된 때에는
                              그때)로부터 2시간 이상 또는 월별누적시간 12시간을
                              초과하여 중지 또는 장애로 인한 피해에 대하여 최근
                              3개월(3개월 미만이면 해당 기간 적용)의 1일 평균
                              요금에 제공 중지 또는 장애 시간을 24로 나눈 수를
                              곱하여 산출한 금액의 한도 내에서 회원과 협의하여
                              배상합니다. 이때 단수가 1시간 미만이면 1시간으로
                              합니다.
                            </p>
                            <p className="contents">
                              본 약관의 규정을 위반하여 회사에 손해를 끼친
                              회원은 회사에 발생하는 모든 손해를 배상해야
                              합니다.
                            </p>
                            <p className="contents">
                              회원이 유료상품을 이용하면서 불법행위를 하였거나
                              본 약관을 위반하여 회사가 해당 회원 이외의
                              제3자로부터 손해배상 청구 또는 소송을 비롯한 각종
                              이의를 제기 받는다면 해당 회원은 자신의 책임과
                              비용으로 회사를 면책시켜야 하며, 이와 관련하여
                              회사에 발생한 모든 손해를 배상해야 합니다.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">제11조 (면책사항)</h4>
                            <p className="contents">
                              회사는 천재지변이나 그와 비슷한 불가항력으로
                              유료상품을 제공할 수 없게 된다면 그 제공에 대한
                              책임이 면제됩니다.
                            </p>
                            <p className="contents">
                              회사는 전기통신서비스 특성상 불가피한 사유로
                              서비스를 제공할 수 없거나 관련 설비의 보수, 교체,
                              정기점검, 공사 등 부득이한 사유로 일시적으로
                              서비스를 중단하게 된다면 그것에 대해 책임을 지지
                              않습니다.
                            </p>
                            <p className="contents">
                              고의, 과실 또는 서비스 이용방법의 미숙지 등 회원의
                              귀책사유로 말미암아 회원의 서비스 이용에 장애가
                              발생하고, 회원 정보나 자료가 소실되는 등 회원에게
                              손해가 발생했을 때 회사는 책임을 지지 않습니다.
                            </p>
                            <p className="contents">
                              회원이 신상정보와 이메일(e-mail) 주소를 부실하게
                              기재하여 손해가 발생했을 때 회사는 책임을 지지
                              않습니다.
                            </p>
                            <p className="contents">
                              회사는 회원이 유료상품을 이용하여 기대하는 수익을
                              상실한 것에 대하여 책임을 지지 않으며, 그 밖의
                              유료상품을 통하여 얻은 자료로 손해가 발생했을
                              때에도 책임을 지지 않습니다.
                            </p>
                            <p className="contents">
                              회사는 회원이 유료상품을 이용하여 자료를
                              게시?전송?저장?조회했을 때 발생하는 법적인 문제에
                              대해 책임을 지지 않습니다.
                            </p>
                            <p className="contents">
                              회사는 회원 상호 간 또는 회원과 제3자 상호 간에
                              서비스를 매개로 발생한 분쟁에 개입할 의무가 없으며
                              이 때문에 발생한 손해를 배상할 책임도 없습니다.
                            </p>
                            <p className="contents">
                              회원이 자신의 개인정보를 타인에게 유출 또는
                              제공하거나, 아이디(ID)와 비밀번호(PASSWORD)의 분실
                              및 무단 사용, 관리소홀 등으로 피해가 발생했을 때
                              회사는 일절 책임을 지지 않습니다.
                            </p>
                            <p className="contents">
                              회사는 회원의 컴퓨터 오류, 제3자 제공 프로그램의
                              종료 및 오류, 네트워크 환경상의 장애 및 오류로
                              파일이 손상되었거나 업로드 도중에 파일이 잘못
                              저장된 것에 대해 책임을 지지 않습니다.
                            </p>
                            <p className="contents">
                              회원상태 변경, 계약만료 또는 요금 미납의 결과로
                              회원계정이 정지되거나 보관파일이 삭제되어 회원에게
                              손해가 발생했을 때 회사는 책임을 지지 않습니다.
                            </p>
                            <p className="contents">
                              서비스 화면에서 링크, 배너 등으로 연결된 회사(이하
                              피연결회사)와 회원 간에 이루어진 거래에 회사는
                              개입하지 않으며, 해당 거래에 대해 책임을 지지
                              않습니다.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">제12조 (재판권 관할)</h4>
                            <p className="contents">
                              회사와 회원간 발생한 분쟁에 관한 소송은 민사소송법
                              등 관련 법령에 따른 관할법원에 제소합니다.
                            </p>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <h3 className="title">부칙</h3>
                        <p className="contents">
                          본 약관은 2020년 11월 01일 부터 적용됩니다.
                        </p>
                      </li>
                    </ul>
                  </div>
                )}

              {window.sessionStorage.getItem("product") === "WRAPSODY" &&
                language === "en" && (
                  <div className="inner modalWindow">
                    <ul>
                      <li>
                        <h3 className="title">Chapter 1 General Provisions</h3>
                        <ul>
                          <li>
                            <h4 className="subTitle">Article 1 (Purpose)</h4>
                            <p className="contents">
                              These provisions aim to prescribe Fasoo Co., Ltd
                              (hereafter "the Company") and its users' rights,
                              obligations, and responsibilities in using wired
                              and wireless internet service, Wrapsody service
                              (hereafter "the Service").
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              Article 2 (Effect and Changes of Terms of
                              Services)
                            </h4>
                            <p className="contents">
                              The contents of these Terms of Services are posted
                              on the service's Internet homepage
                              (http://www.wrapsody.com, hereinafter "Home page")
                              service screen or otherwise disclosed to the
                              member, and payment takes effect when the member
                              who agrees to this, subscribes to the paid
                              product, and pays for it.
                            </p>
                            <p className="contents">
                              The company can change these Terms of Services if
                              it is deemed necessary. When the company changes
                              the terms and conditions, the date of application
                              and the reason for the change are specifically
                              stated and announced 14 days before the date of
                              application in the same manner of this article.
                              However, If the modification is unfavorable to
                              users, the Company shall post 30 days' prior
                              notice of such change and notify members
                              individually via email or etc. (If it is difficult
                              to notify the member individually due to the
                              member's contact information not being written or
                              changed, the notice of the change is posted on the
                              "homepage" to replace the individual notice.)
                            </p>
                            <p className="contents">
                              If the company has taken measures as described in
                              this article when changing this Terms of Service,
                              the Company is not responsible for the member's
                              damage caused by ignorance of the changed Terms of
                              Service
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              Article 3 (Other terms and conditions)
                            </h4>
                            <p className="contents">
                              Any matters that are not prescribed in this Terms
                              of Service shall be subject to the relevant laws
                              and regulations such as the Act on Promotion of
                              Information and Communication Network Utilization
                              and Information Protection (hereinafter
                              "Information and Communication Network Act"), the
                              Basic Telecommunications Act, and the
                              Telecommunications Business Act, as well as the
                              detailed guidelines to use the Service set by the
                              Company.
                            </p>
                            <p className="contents">
                              The Company, if deemed necessary, can set detailed
                              guidelines to use the Service and announce them in
                              a way described in Article 2.
                            </p>
                            <p className="contents">
                              The contents that the company announces on the
                              bulletin board of the homepage regarding company's
                              policy changes, enactment and amendment of
                              legislation, and public notices or guidelines of
                              public institutions in relation to these terms and
                              conditions, also form part of the use agreement.
                            </p>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <h3 className="title">
                          Article 2 Service Use Contract of Paid Plans
                        </h3>
                        <ul>
                          <li>
                            <h4 className="subTitle">
                              Article 4 (Establishment of contract of use)
                            </h4>
                            <p className="contents">
                              The use agreement is established by the Company
                              when the person who wants to become a member
                              agrees to the Terms of Services and the company
                              accepts the "application of paid product
                              purchase".
                            </p>
                            <p className="contents">
                              The contract for the use of the paid service
                              between the company and the member is established
                              at the time when the company's consent reaches the
                              member (when the indication of "purchase/payment,
                              etc." of the paid service is displayed
                              procedurally to the member).
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              Article 5 (Purchase Request)
                            </h4>
                            <p className="contents">
                              The person who wants to be a member fills out the
                              necessary information according to the purchase
                              application form determined by the company.
                            </p>
                            <p className="contents">
                              Applicants for purchases may be restricted from
                              using the service if they steal information from
                              others, or they may be punished according to
                              related laws.
                            </p>
                            <p className="contents">
                              When purchasing, you must not provide false
                              information, and the company is not responsible
                              for any problems caused by false information.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              Article 6 (Acceptance and Limitation of Purchase
                              Request)
                            </h4>
                            <p className="contents">
                              The Company accepts the use of the service in the
                              order in which it is received if there is no
                              business or technical obstacle to the member who
                              requested purchase according to the regulations in
                              Article 6.
                            </p>
                            <p className="contents">
                              The company may not approve or withhold consent
                              for any of the following cases:
                            </p>
                            <ul>
                              <li>
                                <p className="contents">
                                  ① In the case of abnormal use determined by
                                  the Wrapsody operating principle
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  ② In case of infringement or possible
                                  infringement of copyrights of others and
                                  distribution exhibitions of pornography
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  ③ When illegal methods are used for services,
                                  such as using malicious programs and bugs or
                                  exploiting system vulnerabilities.
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  ④ When trying to use the service to make
                                  profit
                                </p>
                              </li>
                              <li>
                                <p className="contents">
                                  ⑤ When violating other regulations prescribed
                                  by the Companies
                                </p>
                              </li>
                            </ul>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              Article 7 (Types of Paid Products)
                            </h4>
                            <p className="contents">
                              Information related to the types of paid products,
                              usage fees, etc. is guided through each product
                              page.
                            </p>
                            <p className="contents">
                              The Company may change paid products from time to
                              time, or discontinue the sale of those products,
                              and add new or event products through a certain
                              period of notice.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              Article 8 (Suspension and Change of Paid Products)
                            </h4>
                            <p className="contents">
                              If it is not possible to provide paid products for
                              reasons such as conversion of business items,
                              abandonment of business, integration between
                              companies, and out of stock, the company notifies
                              the user in the manner specified in the Terms of
                              Service of the Service and compensates the member
                              under the conditions originally proposed by the
                              Company.
                            </p>
                            <p className="contents">
                              Changes to paid products are notified to users who
                              have received or applied for the paid products. In
                              this case, the Company may stop providing the
                              product or cancel the contract, and refunds, etc.
                              will be performed according to the refund
                              procedure for each paid product fee, and stop
                              charging the paid product in proportion to the
                              remaining number of days or refund the relevant
                              price within 3 business days from the termination
                              date. When the company delays the refund of the
                              price to the member, the delayed interest
                              calculated by multiplying the delayed interest
                              rate prescribed by the Enforcement Decree of the
                              Act on Consumer Protection in Electronic Commerce,
                              etc. should be paid for the delayed period.
                            </p>
                            <p className="contents">
                              If you purchase additional paid products, it will
                              be calculated and charged daily until the end of
                              subscription of the existing purchased products,
                              and will be charged at the time of subscription
                              renewal.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              Article 9 (Withdrawal of Subscription and Return
                              of Fees)
                            </h4>
                            <p className="contents">
                              Members can withdraw their subscription of paid
                              products if they have not use the products within
                              7 days from the purchasing date. If the member
                              cancels the paid product for reasons attributable
                              to the company, it is subject to Article 10.
                            </p>
                            <p className="contents">
                              The company will return the fee if the fee is
                              incorrectly paid. However, if the user agrees or
                              does not respond to the company's return notice,
                              the charge may be deducted from the next month's
                              rate. The company will return the fee in case of
                              erroneous payment. However, if the user agrees or
                              does not respond to the company's return notice,
                              the charge may be deducted from the next month's
                              rate.
                            </p>
                            <p className="contents">
                              The company can offset the unpaid charges and
                              return the balance if there are unpaid charges for
                              users who need to return the charges.
                            </p>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <h3 className="title">
                          Chapter 3 Compensation and Disclaimer
                        </h3>
                        <ul>
                          <li>
                            <h4 className="subTitle">
                              Article 10 (Compensation for Damages)
                            </h4>
                            <p className="contents">
                              If the member cannot use the "Paid Service" due to
                              the Company's fault, the company compensates for
                              this except when it is normalized within 2 hours
                              after the member reports the fact that the Service
                              is not available.
                            </p>
                            <p className="contents">
                              If the member is unable to use the paid product
                              due to the company's fault, the company
                              compensates the damage after consulting the member
                              for the damage that has been lasted for more than
                              2 hours from when the member notifies the company
                              (when the company recognizes if they recognize
                              earlier than the user) or when accumulated damages
                              caused by suspension or failure of each month
                              exceeds 12 hours within the limit of the amount
                              calculated by multiplying the average daily rate
                              for the last 3 months (the applicable period if it
                              is less than 3 months) by the number of suspension
                              or failure hours divided by 24.
                            </p>
                            <p className="contents">
                              Members who damage the company in violation of the
                              provisions of these terms and conditions must
                              compensate all damages incurred by the company.
                            </p>
                            <p className="contents">
                              If a member has illegally acted while using a paid
                              product or violated these Terms of Services and
                              the Company receives various complaints including
                              claims for damages or lawsuits from third parties
                              other than the member, the member should indemnify
                              and reimburse any damages to the company.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              Article 11 (Disclaimer)
                            </h4>
                            <p className="contents">
                              If the Company is unable to provide the Paid
                              Service due to a natural disaster or equivalent
                              force majeure, the Company is exempted from
                              liability for Service provision.
                            </p>
                            <p className="contents">
                              The Company is not responsible for the inability
                              to provide the service due to the inevitable
                              reasons of the telecommunication service or
                              temporarily stop the service due to unavoidable
                              reasons such as repair, replacement, regular
                              inspection, and construction of related
                              facilities.
                            </p>
                            <p className="contents">
                              The Company is not responsible for any damage
                              caused to the member, such as intentional,
                              negligent or inadequate use of the service, due to
                              the member's fault, the member's use of the
                              service, and loss of member information or data.
                            </p>
                            <p className="contents">
                              The Company is not responsible for any loss caused
                              by the member's incorrect information and e-mail
                              address.
                            </p>
                            <p className="contents">
                              The Company is not responsible for losing the
                              expected profits of members using paid products,
                              and is not responsible for damages caused by data
                              obtained through other paid products.
                            </p>
                            <p className="contents">
                              The Company is not responsible for any legal
                              issues arising when a member posts, transmits,
                              stores, or queries data using paid products.
                            </p>
                            <p className="contents">
                              The Company is not obliged to intervene in
                              disputes between members or between a member and a
                              third party that arose from the service as a
                              medium, and is not responsible for reimbursing
                              damages.
                            </p>
                            <p className="contents">
                              The Company is not responsible for any loss or
                              damage caused by the loss or unauthorized use of
                              the ID and password, or the negligence of
                              management, if the member leaks or provides his or
                              her personal information to others.
                            </p>
                            <p className="contents">
                              The Company is not responsible for any damage to
                              the file due to a member's computer error,
                              termination and error of a third-party-provided
                              program, failures or errors in the network
                              environment, or incorrect storage of the file
                              during upload.
                            </p>
                            <p className="contents">
                              The Company is not responsible for any damage to
                              the member when account is suspended or the
                              archive file is deleted as a result of membership
                              status change, contract expiration, or failure to
                              pay the fee.
                            </p>
                            <p className="contents">
                              The Company does not intervene in the transactions
                              made between the company (hereinafter referred to
                              as the linked company) linked to the service
                              screen suing links or banners and its members, and
                              is not responsible for the transactions.
                            </p>
                          </li>
                          <li>
                            <h4 className="subTitle">
                              Article 12 (Jurisdictions)
                            </h4>
                            <p className="contents">
                              Lawsuits related to disputes between the company
                              and members are filed with the competent court
                              according to related laws such as the Civil
                              Procedure Act.
                            </p>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <h3 className="title">Supplementary provisions</h3>
                        <p className="contents">
                          These Terms of Service takes effect on November 1,
                          2020.
                        </p>
                      </li>
                    </ul>
                  </div>
                )}
            </div> */}
          </div>
        </Modal.Body>
      </Modal.Dialog>
    </Modal>
  );
};

export default JoinPolicyUI;
